import store from '@/store'
import { showError, showWarning, showMessage } from '@/js/utils/messageHelper'
import axios from 'axios'
import { toRaw } from 'vue'
import * as turf from '@turf/turf'
import {
  addDraw,
  featureCollectionAdd,
  featuresDelete,
  formatYmdHms,
  isJsonString,
  markerAddAndRemove,
  recenterGeoJSON,
  removeNini,
  removeThumbnailMarkerByKey,
  saveDrowFeatures,
  savePointSima,
  toResolved,
  truncate,
  vConfirm,
  zahyokei,
  pushMyDrawUndoAction,
} from '@/js/downLoad'
import { clickCircleSource, clickPointSource, endPointSouce, vertexSource } from '@/js/layers'
import { calculatePolygonMetrics, closeAllPopups } from '@/js/popup'
import JSZip from 'jszip'
export let currentIndex = 0
let kasen

// ヘルパー関数: source._dataからGeoJSONを安全に取得
// MapLibre 5.13.0以降、_dataがProxyオブジェクトになる場合がある
function getSourceData(source) {
  if (!source || !source._data) return null
  const rawData = source._data
  return rawData && rawData.geojson ? rawData.geojson : rawData
}

export default function pyramid() {
  // チェックマークの表示を更新するヘルパー関数
  function updateColorCheckmarks(colorClass, selectedColor) {
    // 指定されたクラスのすべての色選択要素を取得
    const colorElements = document.querySelectorAll(`.${colorClass}`)

    colorElements.forEach((el) => {
      const dataColor = el.getAttribute('data-color')
      // 既存のチェックマークを削除
      const existingCheck = el.querySelector('.color-check-icon')
      if (existingCheck) {
        existingCheck.remove()
      }

      // 選択された色にチェックマークを追加
      if (dataColor === selectedColor) {
        const checkIcon = document.createElement('span')
        // 色によってチェックマークのクラスを変更
        if (dataColor === 'black') {
          checkIcon.className = 'color-check-icon white-check'
        } else if (dataColor === 'rgba(0,0,0,0)') {
          checkIcon.className = 'color-check-icon gray-check'
        } else {
          checkIcon.className = 'color-check-icon'
        }
        checkIcon.textContent = '✓'

        // text-color, point-color, circle-line-colorにはマーカーがあるのでそのまま追加
        el.appendChild(checkIcon)
      }
    })
  }

  ;['map01', 'map02'].forEach((mapName) => {
    const mapElm = document.querySelector('#' + mapName)
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      // e.stopPropagation()
      if (e.target && e.target.classList.contains('pyramid-syochiiki-r02')) {
        store.state.cdArea = e.target.getAttribute('cdArea')
        store.state.syochiikiName = e.target.getAttribute('syochiikiname')
        store.state.isEstat = true
        const cityCode = store.state.cdArea.slice(0, 5)
        const azaCode = store.state.cdArea.slice(5)
        axios
          .get('https://kenzkenz.xsrv.jp/open-hinata/php/pyramid.php', {
            params: {
              cityCode: cityCode,
              azaCode: azaCode,
            },
          })
          .then(function (response) {
            const dataMan = []
            const dataWoman = []
            const dataSousu = []
            response.data.forEach((v) => {
              if (v.男女 === '男') {
                dataMan.push({ class: '0～4歳', man: Number(v['0～4歳']) })
                dataMan.push({ class: '5～9歳', man: Number(v['5～9歳']) })
                dataMan.push({ class: '10～14歳', man: Number(v['10～14歳']) })
                dataMan.push({ class: '15～19歳', man: Number(v['15～19歳']) })
                dataMan.push({ class: '20～24歳', man: Number(v['20～24歳']) })
                dataMan.push({ class: '25～29歳', man: Number(v['25～29歳']) })
                dataMan.push({ class: '30～34歳', man: Number(v['30～34歳']) })
                dataMan.push({ class: '35～39歳', man: Number(v['35～39歳']) })
                dataMan.push({ class: '40～44歳', man: Number(v['40～44歳']) })
                dataMan.push({ class: '45～49歳', man: Number(v['45～49歳']) })
                dataMan.push({ class: '50～54歳', man: Number(v['50～54歳']) })
                dataMan.push({ class: '55～59歳', man: Number(v['55～59歳']) })
                dataMan.push({ class: '60～64歳', man: Number(v['60～64歳']) })
                dataMan.push({ class: '65～69歳', man: Number(v['65～69歳']) })
                dataMan.push({ class: '70～74歳', man: Number(v['70～74歳']) })
                dataMan.push({ class: '75～79歳', man: Number(v['75～79歳']) })
                dataMan.push({ class: '80～84歳', man: Number(v['80～84歳']) })
                dataMan.push({ class: '85～89歳', man: Number(v['85～89歳']) })
                dataMan.push({ class: '90～94歳', man: Number(v['90～94歳']) })
                dataMan.push({ class: '95～99歳', man: Number(v['95～99歳']) })
                dataMan.push({ class: '100歳以上', man: Number(v['100歳以上']) })
              } else if (v.男女 === '女') {
                dataWoman.push({ woman: Number(v['0～4歳']) })
                dataWoman.push({ woman: Number(v['5～9歳']) })
                dataWoman.push({ woman: Number(v['10～14歳']) })
                dataWoman.push({ woman: Number(v['15～19歳']) })
                dataWoman.push({ woman: Number(v['20～24歳']) })
                dataWoman.push({ woman: Number(v['25～29歳']) })
                dataWoman.push({ woman: Number(v['30～34歳']) })
                dataWoman.push({ woman: Number(v['35～39歳']) })
                dataWoman.push({ woman: Number(v['40～44歳']) })
                dataWoman.push({ woman: Number(v['45～49歳']) })
                dataWoman.push({ woman: Number(v['50～54歳']) })
                dataWoman.push({ woman: Number(v['55～59歳']) })
                dataWoman.push({ woman: Number(v['60～64歳']) })
                dataWoman.push({ woman: Number(v['65～69歳']) })
                dataWoman.push({ woman: Number(v['70～74歳']) })
                dataWoman.push({ woman: Number(v['75～79歳']) })
                dataWoman.push({ woman: Number(v['80～84歳']) })
                dataWoman.push({ woman: Number(v['85～89歳']) })
                dataWoman.push({ woman: Number(v['90～94歳']) })
                dataWoman.push({ woman: Number(v['95～99歳']) })
                dataWoman.push({ woman: Number(v['100歳以上']) })
              } else if (v.男女 === '総数') {
                dataSousu.push({ class: '総数', 総数: Number(v['総数']) })
                dataSousu.push({ class: '総数', over65: Number(v['65歳以上']) })
                dataSousu.push({ class: '総数', 平均年齢: Number(v['平均年齢']) })
                dataSousu.push({ class: '総数', 秘匿処理: v['秘匿処理'] })
              }
            })
            const data = dataMan.map((v, i) => {
              return Object.assign(v, dataWoman[i])
            })
            const sousu = dataSousu[0]['総数']
            const over65 = dataSousu[1].over65
            const heikinnenrei = dataSousu[2]['平均年齢'].toFixed(2) + '歳'
            let koureikaritu
            if (isNaN(over65)) {
              koureikaritu = '0%'
            } else {
              koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
            }
            const hitokuSyori = dataSousu[3]['秘匿処理']
            if (hitokuSyori === '秘匿地域') {
              showWarning('秘匿地域です。人口ピラミッドは作成されません。')
              return
            }
            store.state.koureikaritu = koureikaritu
            store.state.heikinnenrei = heikinnenrei
            store.state.kokuchoYear = e.target.getAttribute('year')
            store.state.estatDataset = data

            store.commit('incrDialog2Id')
            store.commit('incrDialogMaxZindex')
            let left
            if (window.innerWidth < 600) {
              left = window.innerWidth / 2 - 175 + 'px'
            } else {
              left = document.querySelector('#' + mapName).clientWidth - 560 + 'px'
            }
            // left = 0
            const dialog = {
              id: store.state.dialog2Id,
              name: 'pyramid',
              style: {
                display: 'block',
                top: '60px',
                left: left,
                'z-index': store.state.dialogMaxZindex,
              },
            }
            store.commit('pushDialogs2', { mapName: mapName, dialog: dialog })
          })
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    function h27syochiiki(e, mapName, year) {
      store.state.cdArea = e.target.getAttribute('cdArea')
      store.state.syochiikiName = e.target.getAttribute('syochiikiname')
      store.state.isEstat = true
      const cityCode = store.state.cdArea.slice(0, 5)
      const azaCode = store.state.cdArea.slice(5)
      axios
        .get('https://kenzkenz.xsrv.jp/open-hinata/php/pyramid2015.php', {
          params: {
            cityCode: cityCode,
            azaCode: azaCode,
            year: year,
          },
        })
        .then(function (response) {
          if (response.data.error) {
            showError('データがありません。地区変更等があったかもしれません。')
            return
          }
          const dataSet = []
          const dataSousu = []
          response.data.forEach((v) => {
            dataSet.push({ class: '0～4歳', man: Number(v['男0～4歳']), woman: Number(v['女0～4歳']) })
            dataSet.push({ class: '5～9歳', man: Number(v['男5～9歳']), woman: Number(v['女5～9歳']) })
            dataSet.push({ class: '10～14歳', man: Number(v['男10～14歳']), woman: Number(v['女10～14歳']) })
            dataSet.push({ class: '15～19歳', man: Number(v['男15～19歳']), woman: Number(v['女15～19歳']) })
            dataSet.push({ class: '20～24歳', man: Number(v['男20～24歳']), woman: Number(v['女20～24歳']) })
            dataSet.push({ class: '25～29歳', man: Number(v['男25～29歳']), woman: Number(v['女25～29歳']) })
            dataSet.push({ class: '30～34歳', man: Number(v['男30～34歳']), woman: Number(v['女30～34歳']) })
            dataSet.push({ class: '35～39歳', man: Number(v['男35～39歳']), woman: Number(v['女35～39歳']) })
            dataSet.push({ class: '40～44歳', man: Number(v['男40～44歳']), woman: Number(v['女40～44歳']) })
            dataSet.push({ class: '45～49歳', man: Number(v['男45～49歳']), woman: Number(v['女45～49歳']) })
            dataSet.push({ class: '50～54歳', man: Number(v['男50～54歳']), woman: Number(v['女50～54歳']) })
            dataSet.push({ class: '55～59歳', man: Number(v['男55～59歳']), woman: Number(v['女55～59歳']) })
            dataSet.push({ class: '60～64歳', man: Number(v['男60～64歳']), woman: Number(v['女60～64歳']) })
            dataSet.push({ class: '65～69歳', man: Number(v['男65～69歳']), woman: Number(v['女65～69歳']) })
            dataSet.push({ class: '70～74歳', man: Number(v['男70～74歳']), woman: Number(v['女70～74歳']) })
            dataSet.push({ class: '75～79歳', man: Number(v['男75～79歳']), woman: Number(v['女75～79歳']) })
            dataSet.push({ class: '80～84歳', man: Number(v['男80～84歳']), woman: Number(v['女80～84歳']) })
            dataSet.push({ class: '85～89歳', man: Number(v['男85～89歳']), woman: Number(v['女85～89歳']) })
            dataSet.push({ class: '90～94歳', man: Number(v['男90～94歳']), woman: Number(v['女90～94歳']) })
            dataSet.push({ class: '95～99歳', man: Number(v['男95～99歳']), woman: Number(v['女95～99歳']) })
            dataSet.push({ class: '100歳以上', man: Number(v['男100歳以上']), woman: Number(v['女100歳以上']) })

            dataSousu.push({ class: '総数', 総数: Number(v['総数']) })
            dataSousu.push({ class: '総数', 総数65歳以上: Number(v['65歳以上']) })
            dataSousu.push({ class: '総数', 平均年齢: Number(v['平均年齢']) })
            dataSousu.push({ class: '総数', 秘匿処理: v['秘匿処理'] })
          })

          const sousu = dataSousu[0]['総数']
          const over65 = dataSousu[1]['総数65歳以上']
          const heikinnenrei = dataSousu[2]['平均年齢'].toFixed(2) + '歳'
          let koureikaritu
          if (isNaN(over65)) {
            koureikaritu = '0%'
          } else {
            koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
          }
          const hitokuSyori = dataSousu[3]['秘匿処理']
          if (hitokuSyori === '秘匿地域') {
            showWarning('秘匿地域です。人口ピラミッドは作成されません。')
            return
          }
          store.state.koureikaritu = koureikaritu
          store.state.heikinnenrei = heikinnenrei
          store.state.kokuchoYear = year

          store.state.estatDataset = dataSet

          store.commit('incrDialog2Id')
          store.commit('incrDialogMaxZindex')
          let left
          if (window.innerWidth < 600) {
            left = window.innerWidth / 2 - 175 + 'px'
          } else {
            left = document.querySelector('#' + mapName).clientWidth - 560 + 'px'
          }
          const diialog = {
            id: store.state.dialog2Id,
            name: 'pyramid',
            style: {
              display: 'block',
              top: '60px',
              left: left,
              'z-index': store.state.dialogMaxZindex,
            },
          }
          store.commit('pushDialogs2', { mapName: mapName, dialog: diialog })
        })
    }
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('pyramid-syochiiki-h27')) {
        h27syochiiki(e, mapName, 2015)
      }
    })
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('pyramid-syochiiki-h22')) {
        h27syochiiki(e, mapName, 2010)
      }
    })
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('pyramid-syochiiki-h17')) {
        h27syochiiki(e, mapName, 2005)
      }
    })
    // 小地域人口推移--------------------------------------------------------------------------------------------------
    function r2jinkosuii(e) {
      return new Promise((resolve) => {
        store.state.cdArea = e.target.getAttribute('cdArea')
        store.state.syochiikiName = e.target.getAttribute('syochiikiname')
        store.state.isEstat = true
        const cityCode = store.state.cdArea.slice(0, 5)
        const azaCode = store.state.cdArea.slice(5)
        axios
          .get('https://kenzkenz.xsrv.jp/open-hinata/php/pyramid.php', {
            params: {
              cityCode: cityCode,
              azaCode: azaCode,
            },
          })
          .then(function (response) {
            const dataMan = []
            const dataWoman = []
            const dataSousu = []
            response.data.forEach((v) => {
              if (v.男女 === '総数') {
                dataSousu.push({ class: '総数', 総数: Number(v['総数']) })
                dataSousu.push({ class: '総数', over65: Number(v['65歳以上']) })
                dataSousu.push({ class: '総数', 平均年齢: Number(v['平均年齢']) })
                dataSousu.push({ class: '総数', 秘匿処理: v['秘匿処理'] })
                dataSousu.push({ class: '総数', under15: Number(v['15歳未満']) })
                dataSousu.push({ class: '総数', seisan: Number(v['15～64歳']) })
              }
            })
            const data = dataMan.map((v, i) => {
              return Object.assign(v, dataWoman[i])
            })
            const sousu = dataSousu[0]['総数']
            const over65 = dataSousu[1].over65
            const heikinnenrei = dataSousu[2]['平均年齢'].toFixed(2) + '歳'
            let koureikaritu
            if (isNaN(over65)) {
              koureikaritu = '0%'
            } else {
              koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
            }
            const ronenRate = (over65 / sousu) * 100
            const hitokuSyori = dataSousu[3]['秘匿処理']
            if (hitokuSyori === '秘匿地域') {
              showWarning('秘匿地域です。人口ピラミッドは作成されません。')
              return
            }
            const under15 = dataSousu[4].under15
            const nensyoRate = (under15 / sousu) * 100
            const seisan = dataSousu[5].seisan
            const seisanRate = (seisan / sousu) * 100
            resolve({ year: 2020, value: sousu, ronenRate: ronenRate, nensyoRate: nensyoRate, seisanRate: seisanRate })
            store.state.koureikaritu = koureikaritu
            store.state.heikinnenrei = heikinnenrei
            store.state.kokuchoYear = e.target.getAttribute('year')

            store.state.estatDataset = data

            store.commit('incrDialog2Id')
            store.commit('incrDialogMaxZindex')
          })
      })
    }
    // ----------------------------------------------
    function h27jinkosuii(e, mapName, year) {
      return new Promise((resolve) => {
        store.state.cdArea = e.target.getAttribute('cdArea')
        store.state.syochiikiName = e.target.getAttribute('syochiikiname')
        store.state.isEstat = true
        const cityCode = store.state.cdArea.slice(0, 5)
        const azaCode = store.state.cdArea.slice(5)
        axios
          .get('https://kenzkenz.xsrv.jp/open-hinata/php/pyramid2015.php', {
            params: {
              cityCode: cityCode,
              azaCode: azaCode,
              year: year,
            },
          })
          .then(function (response) {
            if (response.data.error) {
              showWarning('地区変更等があったかもしれません。線グラフが０からスタートします。注意してください。')
              resolve({
                year: year,
                value: 0,
                ronenRate: 0,
                nensyoRate: 0,
                seisanRate: 0,
              })
              return
            }
            const dataSet = []
            const dataSousu = []
            response.data.forEach((v) => {
              dataSousu.push({ class: '総数', 総数: Number(v['総数']) })
              dataSousu.push({ class: '総数', 総数65歳以上: Number(v['65歳以上']) })
              dataSousu.push({ class: '総数', 平均年齢: Number(v['平均年齢']) })
              dataSousu.push({ class: '総数', 秘匿処理: v['秘匿処理'] })
              dataSousu.push({ class: '総数', 総数15歳未満: Number(v['15歳未満']) })
              dataSousu.push({ class: '総数', 総数1564歳: Number(v['15～64歳']) })
            })
            const sousu = dataSousu[0]['総数']
            const over65 = dataSousu[1]['総数65歳以上']
            const heikinnenrei = dataSousu[2]['平均年齢'].toFixed(2) + '歳'
            let koureikaritu
            if (isNaN(over65)) {
              koureikaritu = '0%'
            } else {
              koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
            }
            const ronenRate = (over65 / sousu) * 100
            const hitokuSyori = dataSousu[3]['秘匿処理']
            const under15 = dataSousu[4]['総数15歳未満']
            const nensyoRate = (under15 / sousu) * 100
            const seisan = dataSousu[5]['総数1564歳']
            const seisanRate = (seisan / sousu) * 100

            if (hitokuSyori === '秘匿地域') {
              showWarning('過去に秘匿地域でした。線グラフが０からスタートします。注意してください。')
              resolve({
                year: year,
                value: 0,
                ronenRate: 0,
                nensyoRate: 0,
                seisanRate: 0,
              })
              return
            }

            store.state.koureikaritu = koureikaritu
            store.state.heikinnenrei = heikinnenrei
            store.state.kokuchoYear = year
            store.state.estatDataset = dataSet
            resolve({
              year: year,
              value: sousu,
              ronenRate: ronenRate,
              nensyoRate: nensyoRate,
              seisanRate: seisanRate,
              seisan: seisan,
            })
            store.commit('incrDialog2Id')
            store.commit('incrDialogMaxZindex')
          })
      })
    }
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('jinkosuii')) {
        async function sample() {
          const arr = []
          const a2005 = await h27jinkosuii(e, mapName, 2005)
          arr.push(a2005)
          const a2010 = await h27jinkosuii(e, mapName, 2010)
          arr.push(a2010)
          const a2015 = await h27jinkosuii(e, mapName, 2015)
          arr.push(a2015)
          const a2020 = await r2jinkosuii(e, mapName)
          arr.push(a2020)
          return arr
        }
        sample().then((response) => {
          store.state.jinkosuiiDatasetEstat['datasetAll'] = response
          const ronen = response.map((value) => {
            if (isNaN(value.ronenRate)) value.ronenRate = 0
            return { year: value.year, rate: value.ronenRate }
          })
          store.state.jinkosuiiDatasetEstat['datasetRonen'] = ronen
          const nensyo = response.map((value) => {
            if (isNaN(value.nensyoRate)) value.nensyoRate = 0
            return { year: value.year, rate: value.nensyoRate }
          })
          store.state.jinkosuiiDatasetEstat['datasetNensyo'] = nensyo
          const seisan = response.map((value) => {
            if (isNaN(value.seisanRate)) value.seisanRate = 0
            return { year: value.year, rate: value.seisanRate, sousu: value.value, seisan: value.seisan }
          })
          store.state.jinkosuiiDatasetEstat['datasetSeisan'] = seisan
          store.commit('incrDialog2Id')
          store.commit('incrDialogMaxZindex')
          let width
          let left
          if (window.innerWidth < 600) {
            left = window.innerWidth / 2 - 175 + 'px'
          } else {
            left = document.querySelector('#' + mapName).clientWidth - 560 + 'px'
          }
          const diialog = {
            id: store.state.dialog2Id,
            name: 'jinkosuii',
            style: {
              display: 'block',
              width: width,
              top: '60px',
              left: left,
              'z-index': store.state.dialogMaxZindex,
            },
          }
          // store.state.resasOrEstat = 'eStat'
          store.commit('pushDialogs2', { mapName: mapName, dialog: diialog })
        })
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (
        e.target &&
        (e.target.classList.contains('suikei1km-2050') || e.target.classList.contains('suikei500m-2050'))
      ) {
        const MESH_ID = e.target.getAttribute('MESH_ID')
        const suikeiYear = e.target.getAttribute('suikeiYear')
        store.state.MESH_ID = MESH_ID
        store.state.suikeiYear = suikeiYear
        store.state.isEstat = false

        // 使用するエンドポイントをクラスによって切り替え
        const endpoint = e.target.classList.contains('suikei1km-2050')
          ? '/oh3/php/pyramid2.php'
          : '/oh3/php/pyramid3.php'

        axios
          .get(endpoint, {
            params: {
              MESH_ID: MESH_ID,
              suikeiYear: suikeiYear,
            },
          })
          .then(function (response) {
            if (response.data.error) {
              showWarning('まだDBにありません。もう少しお待ちください。')
              return
            }

            const dataSet = []
            const dataSousu = []
            response.data.forEach((v) => {
              dataSet.push({ class: '0～4歳', man: Number(v['男0～4歳']), woman: Number(v['女0～4歳']) })
              dataSet.push({ class: '5～9歳', man: Number(v['男5～9歳']), woman: Number(v['女5～9歳']) })
              dataSet.push({ class: '10～14歳', man: Number(v['男10～14歳']), woman: Number(v['女10～14歳']) })
              dataSet.push({ class: '15～19歳', man: Number(v['男15～19歳']), woman: Number(v['女15～19歳']) })
              dataSet.push({ class: '20～24歳', man: Number(v['男20～24歳']), woman: Number(v['女20～24歳']) })
              dataSet.push({ class: '25～29歳', man: Number(v['男25～29歳']), woman: Number(v['女25～29歳']) })
              dataSet.push({ class: '30～34歳', man: Number(v['男30～34歳']), woman: Number(v['女30～34歳']) })
              dataSet.push({ class: '35～39歳', man: Number(v['男35～39歳']), woman: Number(v['女35～39歳']) })
              dataSet.push({ class: '40～44歳', man: Number(v['男40～44歳']), woman: Number(v['女40～44歳']) })
              dataSet.push({ class: '45～49歳', man: Number(v['男45～49歳']), woman: Number(v['女45～49歳']) })
              dataSet.push({ class: '50～54歳', man: Number(v['男50～54歳']), woman: Number(v['女50～54歳']) })
              dataSet.push({ class: '55～59歳', man: Number(v['男55～59歳']), woman: Number(v['女55～59歳']) })
              dataSet.push({ class: '60～64歳', man: Number(v['男60～64歳']), woman: Number(v['女60～64歳']) })
              dataSet.push({ class: '65～69歳', man: Number(v['男65～69歳']), woman: Number(v['女65～69歳']) })
              dataSet.push({ class: '70～74歳', man: Number(v['男70～74歳']), woman: Number(v['女70～74歳']) })
              dataSet.push({ class: '75～79歳', man: Number(v['男75～79歳']), woman: Number(v['女75～79歳']) })
              dataSet.push({ class: '80～84歳', man: Number(v['男80～84歳']), woman: Number(v['女80～84歳']) })
              dataSet.push({ class: '85～89歳', man: Number(v['男85～89歳']), woman: Number(v['女85～89歳']) })
              dataSet.push({ class: '90歳以上', man: Number(v['男90歳以上']), woman: Number(v['女90歳以上']) })

              dataSousu.push({ class: '総数', 総数: Number(v['総数']) })
              dataSousu.push({ class: '総数', 総数65歳以上: Number(v['65歳以上']) })
            })

            const sousu = dataSousu[0]['総数']
            const over65 = dataSousu[1]['総数65歳以上']
            let koureikaritu
            if (isNaN(over65)) {
              koureikaritu = '0%'
            } else {
              koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
            }
            store.state.koureikaritu = koureikaritu

            store.state.estatDataset = dataSet

            store.commit('incrDialog2Id')
            store.commit('incrDialogMaxZindex')
            let left
            if (window.innerWidth < 600) {
              left = window.innerWidth / 2 - 175 + 'px'
            } else {
              left = document.querySelector('#' + mapName).clientWidth - 560 + 'px'
            }
            const diialog = {
              id: store.state.dialog2Id,
              name: 'pyramid',
              style: {
                display: 'block',
                top: '60px',
                left: left,
                'z-index': store.state.dialogMaxZindex,
              },
            }
            store.commit('pushDialogs2', { mapName: mapName, dialog: diialog })
          })
      }
    })

    // mapElm.addEventListener('click', (e) => {
    //     if (e.target && e.target.classList.contains('suikei1km-2050')) {
    //         const MESH_ID = e.target.getAttribute("MESH_ID")
    //         const suikeiYear = e.target.getAttribute("suikeiYear")
    //         store.state.MESH_ID = MESH_ID
    //         store.state.suikeiYear = suikeiYear
    //         store.state.isEstat = false
    //         axios
    //             .get('/oh3/php/pyramid2.php',{
    //                 params: {
    //                     MESH_ID: MESH_ID,
    //                     suikeiYear: suikeiYear
    //                 }
    //             }).then(function (response) {
    //             if (response.data.error) {
    //                 alert("まだDBにありません。もう少しまってください。")
    //                 return
    //             }
    //
    //             const dataSet = []
    //             const dataSousu = []
    //             response.data.forEach((v) => {
    //                 dataSet.push({class: '0～4歳', man: Number(v['男0～4歳']), woman: Number(v['女0～4歳'])})
    //                 dataSet.push({class: '5～9歳', man: Number(v['男5～9歳']), woman: Number(v['女5～9歳'])})
    //                 dataSet.push({class: '10～14歳', man: Number(v['男10～14歳']), woman: Number(v['女10～14歳'])})
    //                 dataSet.push({class: '15～19歳', man: Number(v['男15～19歳']), woman: Number(v['女15～19歳'])})
    //                 dataSet.push({class: '20～24歳', man: Number(v['男20～24歳']), woman: Number(v['女20～24歳'])})
    //                 dataSet.push({class: '25～29歳', man: Number(v['男25～29歳']), woman: Number(v['女25～29歳'])})
    //                 dataSet.push({class: '30～34歳', man: Number(v['男30～34歳']), woman: Number(v['女30～34歳'])})
    //                 dataSet.push({class: '35～39歳', man: Number(v['男35～39歳']), woman: Number(v['女35～39歳'])})
    //                 dataSet.push({class: '40～44歳', man: Number(v['男40～44歳']), woman: Number(v['女40～44歳'])})
    //                 dataSet.push({class: '45～49歳', man: Number(v['男45～49歳']), woman: Number(v['女45～49歳'])})
    //                 dataSet.push({class: '50～54歳', man: Number(v['男50～54歳']), woman: Number(v['女50～54歳'])})
    //                 dataSet.push({class: '55～59歳', man: Number(v['男55～59歳']), woman: Number(v['女55～59歳'])})
    //                 dataSet.push({class: '60～64歳', man: Number(v['男60～64歳']), woman: Number(v['女60～64歳'])})
    //                 dataSet.push({class: '65～69歳', man: Number(v['男65～69歳']), woman: Number(v['女65～69歳'])})
    //                 dataSet.push({class: '70～74歳', man: Number(v['男70～74歳']), woman: Number(v['女70～74歳'])})
    //                 dataSet.push({class: '75～79歳', man: Number(v['男75～79歳']), woman: Number(v['女75～79歳'])})
    //                 dataSet.push({class: '80～84歳', man: Number(v['男80～84歳']), woman: Number(v['女80～84歳'])})
    //                 dataSet.push({class: '85～89歳', man: Number(v['男85～89歳']), woman: Number(v['女85～89歳'])})
    //                 dataSet.push({class: '90歳以上', man: Number(v['男90歳以上']), woman: Number(v['女90歳以上'])})
    //
    //                 dataSousu.push({class: '総数', 総数: Number(v['総数'])})
    //                 dataSousu.push({class: '総数', 総数65歳以上: Number(v['65歳以上'])})
    //                 // dataSousu.push({class: '総数', 平均年齢: Number(v['平均年齢'])})
    //                 // dataSousu.push({class: '総数', 秘匿処理: v['秘匿処理']})
    //             })
    //
    //             const sousu = dataSousu[0]['総数']
    //             const over65 = dataSousu[1]['総数65歳以上']
    //             let koureikaritu
    //             if (isNaN(over65)) {
    //                 koureikaritu = '0%'
    //             } else {
    //                 koureikaritu = ((over65 / sousu) * 100).toFixed(2) + '%'
    //             }
    //             store.state.koureikaritu = koureikaritu
    //
    //             store.state.estatDataset = dataSet
    //
    //             store.commit('incrDialog2Id');
    //             store.commit('incrDialogMaxZindex');
    //             let left
    //             if (window.innerWidth < 600) {
    //                 left = (window.innerWidth / 2 - 175) + 'px'
    //             } else {
    //                 left = (document.querySelector('#map01').clientWidth - 560) + 'px'
    //             }
    //             const diialog =
    //                 {
    //                     id: store.state.dialog2Id,
    //                     name: 'pyramid',
    //                     style: {
    //                         display: 'block',
    //                         top: '60px',
    //                         left: left,
    //                         'z-index': store.state.dialogMaxZindex
    //                     }
    //                 }
    //             store.commit('pushDialogs2', {mapName: mapName, dialog: diialog})
    //         })
    //     }
    // })
    mapElm.addEventListener('click', (e) => {
      if (
        e.target &&
        (e.target.classList.contains('suikei1km-jinkosuii') || e.target.classList.contains('suikei500m-jinkosuii'))
      ) {
        const MESH_ID = e.target.getAttribute('MESH_ID')
        store.state.MESH_ID = MESH_ID
        store.state.isEstat = false

        // 使用するエンドポイントをクラスによって切り替え
        const endpoint = e.target.classList.contains('suikei1km-jinkosuii')
          ? '/oh3/php/jinkosuii2.php'
          : '/oh3/php/jinkosuii3.php'

        axios
          .get(endpoint, {
            params: {
              MESH_ID: MESH_ID,
            },
          })
          .then(function (response) {
            store.state.jinkosuiiDatasetEstat['datasetAll'] = response.data

            const ronen = response.data.map((value) => {
              if (isNaN(value.ronenRate)) value.ronenRate = 0
              return { year: value.year, rate: value.ronenRate }
            })
            store.state.jinkosuiiDatasetEstat['datasetRonen'] = ronen

            const nensyo = response.data.map((value) => {
              if (isNaN(value.nensyoRate)) value.nensyoRate = 0
              return { year: value.year, rate: value.nensyoRate }
            })
            store.state.jinkosuiiDatasetEstat['datasetNensyo'] = nensyo

            const seisan = response.data.map((value) => {
              if (isNaN(value.seisanRate)) value.seisanRate = 0
              return { year: value.year, rate: value.seisanRate, sousu: value.value, seisan: value.seisan }
            })
            store.state.jinkosuiiDatasetEstat['datasetSeisan'] = seisan

            store.commit('incrDialog2Id')
            store.commit('incrDialogMaxZindex')

            let width
            let left
            if (window.innerWidth < 600) {
              left = window.innerWidth / 2 - 175 + 'px'
            } else {
              left = document.querySelector('#' + mapName).clientWidth - 560 + 'px'
            }

            const diialog = {
              id: store.state.dialog2Id,
              name: 'jinkosuii',
              style: {
                display: 'block',
                width: width,
                top: '60px',
                left: left,
                'z-index': store.state.dialogMaxZindex,
              },
            }
            store.commit('pushDialogs2', { mapName: mapName, dialog: diialog })
          })
      }
    })
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('kyakusu-suii')) {
        const dataset = JSON.parse(e.target.getAttribute('dataset'))
        store.state.jinkosuiiDatasetEstat['datasetAll'] = dataset
        store.state.stationName = e.target.getAttribute('stationname') + '駅'

        store.commit('incrDialog2Id')
        store.commit('incrDialogMaxZindex')

        let width
        let left
        if (window.innerWidth < 600) {
          left = window.innerWidth / 2 - 175 + 'px'
        } else {
          left = document.querySelector('#map01').clientWidth - 560 + 'px'
        }

        const diialog = {
          id: store.state.dialog2Id,
          name: 'kyakususuii',
          style: {
            display: 'block',
            width: width,
            top: '60px',
            left: left,
            'z-index': store.state.dialogMaxZindex,
          },
        }
        store.commit('pushDialogs2', { mapName: mapName, dialog: diialog })
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('kasen-suikei')) {
        const map = store.state[mapName]
        if (map.getFilter('oh-kasen') === undefined) {
          const suikei = e.target.getAttribute('suikei')
          if (suikei !== 'undefined') {
            map.setFilter('oh-kasen', ['==', ['get', 'suikei'], suikei])
            map.setFilter('oh-kasen-label', ['==', ['get', 'suikei'], suikei])
          }
        } else {
          map.setFilter('oh-kasen', null)
          map.setFilter('oh-kasen-label', null)
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('kasen-highlights')) {
        const map = store.state[mapName]
        if (e.target.getAttribute('kasenmei') === '名称不明') {
          showWarning('名称不明の河川は強調できません。')
          return
        }

        // 流域モード用の河川レイヤーIDを決定
        // watershed-filtered-rivers: 流域計算後のGeoJSONレイヤー（最優先）
        // oh-kasen: 通常のOH3レイヤー（フォールバック）
        let kasenLayerId = null
        if (map.getLayer('watershed-filtered-rivers')) {
          kasenLayerId = 'watershed-filtered-rivers'
        } else if (map.getLayer('oh-kasen')) {
          kasenLayerId = 'oh-kasen'
        }

        if (!kasenLayerId) {
          return
        }


        if (kasen === e.target.getAttribute('kasen')) {
          // 強調解除：元のスタイルに戻す
          if (kasenLayerId === 'watershed-filtered-rivers') {
            // GeoJSONレイヤー：元の青に戻す
            map.setPaintProperty(kasenLayerId, 'line-color', '#0066ff')
            map.setPaintProperty(kasenLayerId, 'line-width', [
              'interpolate', ['linear'], ['zoom'],
              8, 1,
              12, 2,
              16, 3,
            ])
          } else {
            // PMTilesレイヤー
            map.setPaintProperty(kasenLayerId, 'line-color', 'blue')
            map.setPaintProperty(kasenLayerId, 'line-width', [
              'interpolate',
              ['linear'],
              ['zoom'],
              1,
              ['*', 0.1, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]],
              11,
              ['*', 0.3, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]],
              18,
              ['*', 2.0, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]],
            ])
          }
          kasen = null
          store.state.kasenCode[mapName] = null
          store.state.kasenMei[mapName] = null
          return
        }

        kasen = e.target.getAttribute('kasen')
        const kasenmei = e.target.getAttribute('kasenmei')
        if (kasen) {
          // 河川を強調表示（色を赤に、幅を太く、対象のみ表示）
          map.setPaintProperty(kasenLayerId, 'line-color', [
            'case',
            ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
            'red',
            kasenLayerId === 'watershed-filtered-rivers' ? '#0066ff' : 'blue'
          ])

          map.setPaintProperty(kasenLayerId, 'line-width', [
            'interpolate',
            ['linear'],
            ['zoom'],
            1, [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              5,
              ['*', 0.1, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]]
            ],
            11, [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              5,
              ['*', 1, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]]
            ],
            12, [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              5,
              ['*', 2, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]]
            ],
            14, [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              5,
              ['*', 3, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]]
            ],
            16, [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              5,
              ['*', 5, ['case', ['==', ['get', 'W05_003'], '1'], 3, 1]]
            ]
          ])

          // 強調対象のみ目立たせる（流域モードでは非強調も表示したままにする）
          if (kasenLayerId !== 'watershed-filtered-rivers') {
            map.setPaintProperty(kasenLayerId, 'line-opacity', [
              'case',
              ['all', ['==', ['get', 'W05_002'], kasen], ['==', ['get', 'W05_004'], kasenmei]],
              1,
              0
            ])
          }

          store.state.kasenCode[mapName] = kasen
          store.state.kasenMei[mapName] = kasenmei
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('bunsuikai-btn')) {
        const map = store.state[mapName]
        if (map.getFilter('oh-bunsuirei') === undefined) {
          const bunsuikai = e.target.getAttribute('bunsuikai')
          if (bunsuikai !== 'undefined') {
            map.setFilter('oh-bunsuirei', ['==', ['get', 'W07_002'], bunsuikai])
            map.setFilter('oh-kasen', ['==', ['get', 'W05_001'], bunsuikai])
            map.setFilter('oh-kasen-label', ['==', ['get', 'W05_001'], bunsuikai])
            store.state.suikeiText[mapName] = bunsuikai
          }
        } else {
          map.setFilter('oh-bunsuirei', null)
          map.setFilter('oh-kasen', null)
          map.setFilter('oh-kasen-label', null)
          store.state.suikeiText[mapName] = ''
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('mura-name')) {
        const map = store.state[mapName]
        if (map.getFilter('oh-mura') === undefined) {
          const mura = e.target.getAttribute('mura')
          if (mura !== 'undefined') {
            map.setFilter('oh-mura', ['==', ['get', 'MURA_NAME'], mura])
            map.setFilter('oh-mura-line', ['==', ['get', 'MURA_NAME'], mura])
            map.setFilter('oh-koaza', ['==', ['get', 'MURA_NAME'], mura])
            map.setFilter('oh-koaza-label', ['==', ['get', 'MURA_NAME'], mura])
            map.setFilter('oh-koaza-line', ['==', ['get', 'MURA_NAME'], mura])
            map.setFilter('oh-mura-center-label', ['==', ['get', 'MURA_NAME'], mura])
            store.state.koazaText[mapName] = mura
          }
        } else {
          map.setFilter('oh-mura', null)
          map.setFilter('oh-mura-line', null)
          map.setFilter('oh-koaza', null)
          map.setFilter('oh-koaza-label', null)
          map.setFilter('oh-koaza-line', null)
          map.setFilter('oh-mura-center-label', null)
          store.state.koazaText[mapName] = ''
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('popup-btn-traffic')) {
        if (e.target.nextElementSibling.style.display === 'none') {
          e.target.nextElementSibling.style.display = 'block'
          document.querySelectorAll('.popup-html-div').forEach((element) => {
            element.scrollTop = 0
          })
        } else {
          e.target.nextElementSibling.style.display = 'none'
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('carousel-button-prev')) {
        const carouselImages = document.querySelector('.carousel-images')
        const images = document.querySelectorAll('.carousel-images img')
        const totalImages = images.length
        function updateCarousel(direction) {
          let offset = 0
          if (direction === 'next') {
            currentIndex = (currentIndex + 1) % totalImages
          } else if (direction === 'prev') {
            currentIndex = (currentIndex - 1 + totalImages) % totalImages
          }
          for (let i = 0; i < currentIndex; i++) {
            offset += images[i].offsetWidth
          }
          carouselImages.style.transform = `translateX(-${offset}px)`
        }
        updateCarousel('prev')
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    // let currentIndex = 0;
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('carousel-button-next')) {
        const carouselImages = document.querySelector('.carousel-images')
        const images = document.querySelectorAll('.carousel-images img')
        const totalImages = images.length
        function updateCarousel(direction) {
          let offset = 0
          if (direction === 'next') {
            currentIndex = (currentIndex + 1) % totalImages
          } else if (direction === 'prev') {
            currentIndex = (currentIndex - 1 + totalImages) % totalImages
          }
          for (let i = 0; i < currentIndex; i++) {
            offset += images[i].offsetWidth
          }
          carouselImages.style.transform = `translateX(-${offset}px)`
        }
        updateCarousel('next')
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('sima-output')) {
        const id = e.target.getAttribute('id')
        const zahyokei = e.target.getAttribute('zahyokei')
        const map = store.state.map01
        const source = map.getSource('click-points-source')
        const pointsGeojson = getSourceData(source)
        // find の戻り値がオブジェクトなので配列に包む
        const foundFeature = pointsGeojson?.features?.find((feature) => String(feature.properties.id) === String(id))
        if (!foundFeature) return
        const pointGeojson = {
          type: 'FeatureCollection',
          features: [foundFeature], // 配列にする
        }
        savePointSima(store.state.map01, pointGeojson, zahyokei)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('sima-output-all')) {
        const zahyokei = e.target.getAttribute('zahyokei')
        const map = store.state.map01
        const source = map.getSource('click-points-source')
        const pointsGeojson = getSourceData(source)
        savePointSima(store.state.map01, pointsGeojson, zahyokei)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('point-delete')) {
        const id = e.target.getAttribute('id')
        const map01 = store.state.map01
        let source01 = map01.getSource('click-points-source')
        let pointsGeojson = getSourceData(source01)
        // 修正: GeoJSON の全体構造を保持する
        pointsGeojson = {
          type: 'FeatureCollection',
          features: pointsGeojson.features.filter((feature) => {
            return String(feature.properties.id) !== String(id)
          }),
        }
        source01.setData(pointsGeojson)
        store.state.clickGeojsonText = JSON.stringify(pointsGeojson)
        store.state.popupDialog = false

        await featuresDelete([id])
        markerAddAndRemove(true)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('point-delete-all')) {
        const map01 = store.state.map01
        let source01 = map01.getSource('click-points-source')
        // 空のGeoJSON FeatureCollectionを設定する
        source01.setData({
          type: 'FeatureCollection',
          features: [],
        })
        store.state.clickGeojsonText = ''
        store.state.popupDialog = false
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target.classList.contains('calc-check')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id')).replace('calc-', '')
        const chkElm = document.querySelector('.calc-check')
        const checked = chkElm.checked
        let value
        if (checked) {
          value = 1
        } else {
          value = 0
        }
        const gejsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, 'calc', value)
        store.state.clickCircleGeojsonText = gejsonText
        generateSegmentLabelGeoJSON(JSON.parse(gejsonText))
        store.state.currentLineCalcCheck = value
        try { localStorage.setItem('oh3.currentLineCalcCheck', value) } catch (_) {}
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target.classList.contains('keiko-check')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id')).replace('keiko-', '')
        const chkElm = document.querySelector('.keiko-check')
        const checked = chkElm.checked
        let value
        if (checked) {
          value = 1
        } else {
          value = 0
        }
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, 'keiko', value)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target.classList.contains('polygon-area-check')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const chkElm = document.querySelector('.polygon-area-check')
        const checked = chkElm.checked
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, 'isArea', checked)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target.classList.contains('circle-radius-check')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id').replace('-radius', ''))
        const pairId = String(e.target.getAttribute('id').replace('-radius', '')) + '-point'
        const chkElm = document.querySelector('.circle-radius-check')
        const checked = chkElm.checked
        const circleTextElm = document.querySelector('.circle-text')
        const textValue = circleTextElm.value
        // centerFeature.properties.label
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, 'isRadius', checked)
        store.state.clickCircleGeojsonText = geojsonUpdate(
          map01,
          null,
          clickCircleSource.iD,
          pairId,
          'isRadius',
          checked
        )
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (
        e.target &&
        (e.target.classList.contains('circle-range') ||
          e.target.classList.contains('circle-text') ||
          e.target.classList.contains('circle200-check') ||
          e.target.classList.contains('circle-radius-input'))
      ) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id')).replace('-200', '')
        const circleRangeElm = document.querySelector('.circle-range')
        const circleTextElm = document.querySelector('.circle-text')
        const circleChkElm = document.querySelector('.circle200-check')
        const circleInput = document.querySelector('.circle-radius-input')
        const rangeValue = Number(circleRangeElm.value)
        const textValue = circleTextElm.value
        const checked = circleChkElm.checked
        const inputValue = Number(circleInput.value)
        store.state.circle200Chk = checked
        let radius = checked ? 200 : Number(rangeValue)
        if (e.target.classList.contains('circle-radius-input')) {
          radius = inputValue
        }
        const lng = Number(circleRangeElm.getAttribute('lng'))
        const lat = Number(circleRangeElm.getAttribute('lat'))
        const coordinates = [lng, lat]
        store.state.coordinates = coordinates
        store.state.clickCircleGeojsonText = geojsonUpdate(
          map01,
          'Circle',
          clickCircleSource.iD,
          id,
          'label',
          textValue,
          radius
        )
        document.querySelector('.circle-label').innerHTML = '半径' + radius + 'm'
        document.querySelector('.circle-text').value = textValue
        document.querySelector('.circle-radius-input').value = String(radius)
        const inputElement = document.querySelector('.circle-radius-input')
        // let radius = 0;
        let isComposing = false
        inputElement.addEventListener('compositionstart', () => {
          isComposing = true
        })
        inputElement.addEventListener('compositionend', () => {
          isComposing = false
        })
        inputElement.addEventListener(
          'input',
          debounce((e) => {
            if (isComposing) return
            const value = e.target.value
            if (!isNaN(value) && value !== '') {
              radius = parseFloat(value)
              setTimeout(() => {
                inputElement.value = String(radius)
                inputElement.focus() // フォーカスを維持
              }, 0)
            }
          }, 300)
        )
        function debounce(func, wait) {
          let timeout
          return function executedFunction(...args) {
            const later = () => {
              clearTimeout(timeout)
              func(...args)
            }
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
          }
        }
        document.querySelector('.circle-range').value = String(radius)
        store.state.currentCircleRadius = radius
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('polygon-text')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const polygonTextElm = document.querySelector('.polygon-text')
        const value = polygonTextElm.value
        const tgtProp = 'label'
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('keyword-item')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const pointTextElm = document.querySelector('.oh-cool-input')
        const value = pointTextElm.value
        const tgtProp = 'label'
        setTimeout(() => {
          store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        }, 100)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('line-text')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const lineTextElm = document.querySelector('.line-text')
        const value = lineTextElm.value
        const tgtProp = 'label'
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        generateStartEndPointsFromGeoJSON(JSON.parse(store.state.clickCircleGeojsonText))
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    /**
     * テスト中。どのような発火が適当かテスト中。今はinput
     */
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('point-text')) {
        store.state.isLabelUpdated = true
        store.state.drawFeatureId = String(e.target.getAttribute('id'))
        lavelUpdate(e)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('keyup', (e) => {
      if (e.target && e.target.classList.contains('point-text')) {
        store.state.isLabelUpdated = true
        store.state.drawFeatureId = String(e.target.getAttribute('id'))
        // lavelUpdate(e)
      }
    })
    mapElm.addEventListener('compositionend', (e) => {
      if (e.target && e.target.classList.contains('point-text')) {
        store.state.isLabelUpdated = true
        store.state.drawFeatureId = String(e.target.getAttribute('id'))
        // lavelUpdate(e)
      }
    })
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('point-text')) {
        store.state.isLabelUpdated = true
        store.state.drawFeatureId = String(e.target.getAttribute('id'))
        // lavelUpdate(e)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('text-color')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = e.target.getAttribute('data-color')
        const tgtProp = 'color'
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        store.state.currentTextColor = value
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('point-color')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = e.target.getAttribute('data-color')
        const tgtProp = 'point-color'
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        store.state.currentPointColor = value
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (
        (e.target && e.target.classList.contains('circle-color')) ||
        e.target.classList.contains('circle-line-color') ||
        e.target.classList.contains('polygon-color')
      ) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        let value = e.target.getAttribute('data-color')
        let tgtProp = 'color'
        if (e.target.classList.contains('circle-color')) {
          store.state.currentCircleColor = value
          value = colorNameToRgba(value, 0.6)
        } else if (e.target.classList.contains('circle-line-color')) {
          store.state.currentCircleLineColor = value
          tgtProp = 'lineColor'
        } else if (e.target.classList.contains('text-color')) {
          store.state.currentTextColor = value
        } else if (e.target.classList.contains('polygon-color')) {
          store.state.currentPolygonColor = value
          const colorName = value
          value = colorNameToRgba(value, 0.6)
          // colorとcolorNameの両方を更新
          geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
          store.state.clickCircleGeojsonText = geojsonUpdate(
            map01,
            null,
            clickCircleSource.iD,
            id,
            'colorName',
            colorName
          )

          // チェックマークの表示を更新
          updateColorCheckmarks('polygon-color', colorName)
        }
        if (!e.target.classList.contains('polygon-color')) {
          store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        }

        // circle-colorとcircle-line-colorのチェックマークも更新
        if (e.target.classList.contains('circle-color')) {
          updateColorCheckmarks('circle-color', e.target.getAttribute('data-color'))
        } else if (e.target.classList.contains('circle-line-color')) {
          updateColorCheckmarks('circle-line-color', e.target.getAttribute('data-color'))
        } else if (e.target.classList.contains('text-color')) {
          updateColorCheckmarks('text-color', value)
        } else if (e.target.classList.contains('point-color')) {
          updateColorCheckmarks('point-color', e.target.getAttribute('data-color'))
        } else if (e.target.classList.contains('line-color')) {
          updateColorCheckmarks('line-color', value)
        }

        const el = document.querySelector(`#txt-marker-${id} .txt-marker-label`)
        if (el) el.style.color = value
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('font-size-input')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = Number(e.target.value)
        const tgtProp = 'text-size'
        const geojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        store.state.clickCircleGeojsonText = geojsonText
        store.state.currentTextSize = value
        const el = document.querySelector(`#txt-marker-${id} .txt-marker-label`)
        if (el) el.style.fontSize = `${value}px`
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('circle-line-width-input')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = Number(e.target.value)
        const tgtProp = 'line-width'
        const geojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        store.state.clickCircleGeojsonText = geojsonText
        store.state.currentCircleLineWidth = value
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', (e) => {
      if (e.target && e.target.classList.contains('line-width-input')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = Number(e.target.value)
        const tgtProp = 'line-width'
        const geojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        store.state.clickCircleGeojsonText = geojsonText
        store.state.currentFreeHandWidth = value
        store.state.currentLineWidth = value
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('arrow-select')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const startId = id + '-start'
        const endId = id + '-end'
        const value = e.target.value
        const tgtProp = 'arrow-type'
        geojsonUpdate(map01, null, endPointSouce.id, startId, tgtProp, value)
        geojsonUpdate(map01, null, endPointSouce.id, endId, tgtProp, value)
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('change', (e) => {
      if (e.target && (e.target.classList.contains('label-select') || e.target.classList.contains('text-select'))) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const value = e.target.value
        const tgtProp = 'labelType'
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
        generateStartEndPointsFromGeoJSON(JSON.parse(store.state.clickCircleGeojsonText))

        if (e.target.classList.contains('label-select')) {
          store.state.currentLineLabelType = value
        } else {
          store.state.currentTextLabelType = value
          if (!store.state.isUsingServerGeojson) {
            featureCollectionAdd()
          }
          const targetFeature = JSON.parse(store.state.clickCircleGeojsonText).features.find(
            (f) => f.properties.id === id
          )
          const key = targetFeature.geometry.coordinates.join()
          removeThumbnailMarkerByKey(key)
          markerAddAndRemove(true)
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('line-color')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const startId = id + '-start'
        const endId = id + '-end'
        const value = e.target.getAttribute('data-color')
        const arrowValue = 'arrow_' + value
        const tgtProp = 'color'
        const arrowTgtProp = 'arrow'
        const keikoValue = neonColors[value]
        geojsonUpdate(map01, null, endPointSouce.id, startId, arrowTgtProp, arrowValue)
        geojsonUpdate(map01, null, endPointSouce.id, endId, arrowTgtProp, arrowValue)
        store.state.clickCircleGeojsonText = geojsonUpdate(
          map01,
          'LineString',
          clickCircleSource.iD,
          id,
          tgtProp,
          value
        )
        // store.state.clickCircleGeojsonText = geojsonUpdate (map01,null,clickCircleSource.iD,id,'keiko-color',keikoValue)
        // store.state.clickCircleGeojsonText = geojsonUpdate (map01,null,clickCircleSource.iD,id,arrowTgtProp,arrowValue)

        store.state.currentFreeHandKeikoColor = keikoValue
        store.state.currentLineColor = value
        store.state.currentArrowColor = arrowValue
        if (isJsonString(store.state.clickCircleGeojsonText)) {
          generateStartEndPointsFromGeoJSON(JSON.parse(store.state.clickCircleGeojsonText))
        }
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('remove-others')) {
        store.state.saveHistoryFire = !store.state.saveHistoryFire
        setTimeout(async () => {
          const map01 = store.state.map01
          const id = String(e.target.getAttribute('id'))
          let source = map01.getSource(clickCircleSource.iD)
          const geojson = getSourceData(source)
          if (geojson && geojson.features) {
            let newFeatures = []
            let deleteIds = []
            const isLasso = geojson.features.find((feature) => {
              return String(feature.properties.id) === id && feature.properties.lassoSelected === true
            })
            if (isLasso) {
              newFeatures = geojson.features.filter((feature) => {
                return feature.properties.lassoSelected === true
              })
              deleteIds =
                geojson.features
                  .filter((feature) => feature.properties.lassoSelected !== true)
                  .map((f) => f.properties.id) ?? []
            } else {
              newFeatures = geojson.features.filter((feature) => {
                return String(feature.properties.id) === id || String(feature.properties.pairId) === id
              })
              deleteIds =
                geojson.features
                  .filter((feature) => String(feature.properties.id) !== id && String(feature.properties.pairId) !== id)
                  .map((f) => f.properties.id) ?? []
            }
            if (newFeatures.length !== geojson.features.length) {
              geojson.features = newFeatures
              map01.getSource(clickCircleSource.iD).setData(geojson)
              store.state.clickCircleGeojsonText = JSON.stringify(geojson)
              await featuresDelete(deleteIds)
            }
          }
          store.state.isCursorOnPanel = false
          closeAllPopups()
          store.state.popupDialog = false
          store.commit('setDrawDrawer', false)
        }, 100)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('point-delete')) {
        store.state.saveHistoryFire = !store.state.saveHistoryFire
        setTimeout(() => {
          const map01 = store.state.map01
          const id = String(e.target.getAttribute('id'))
          let source = map01.getSource(clickCircleSource.iD)
          const geojson = getSourceData(source)
          if (geojson && geojson.features) {
            const newFeatures = geojson.features.filter((feature) => {
              return !(feature.properties && String(feature.properties.id) === id)
            })
            if (newFeatures.length !== geojson.features.length) {
              geojson.features = newFeatures
              map01.getSource(clickCircleSource.iD).setData(geojson)
              store.state.clickCircleGeojsonText = JSON.stringify(geojson)
            }
          }
          store.state.isCursorOnPanel = false
          closeAllPopups()
          store.state.popupDialog = false
          store.commit('setDrawDrawer', false)
          if (!store.state.isUsingServerGeojson) {
            featureCollectionAdd()
            markerAddAndRemove(true)
          }
        }, 100)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && (e.target.classList.contains('circle-delete') || e.target.classList.contains('line-delete'))) {
        store.state.saveHistoryFire = !store.state.saveHistoryFire
        setTimeout(async () => {
          const map01 = store.state.map01
          const id = String(e.target.getAttribute('id'))
          let source = map01.getSource(clickCircleSource.iD)
          const geojson = getSourceData(source)
          let lasso = false
          if (
            geojson.features.find(
              (feature) => feature.properties.id === id && feature.properties.lassoSelected === true
            )
          ) {
            lasso = true
          }
          const pairIds = geojson.features
            .filter((feature) => String(feature.properties.pairId) === id)
            .map((f) => f.properties.id)
          const newFeatures = geojson.features.filter((feature) => {
            if (lasso) {
              return !feature.properties.lassoSelected
            } else {
              return String(feature.properties.id) !== id && String(feature.properties.pairId) !== id
            }
          })
          if (newFeatures.length !== geojson.features.length) {
            geojson.features = newFeatures
            map01.getSource(clickCircleSource.iD).setData(geojson)
            store.state.clickCircleGeojsonText = JSON.stringify(geojson)
          }

          store.state.isCursorOnPanel = false
          closeAllPopups()
          store.state.popupDialog = false
          await featuresDelete([id, ...pairIds])
          store.commit('setDrawDrawer', false)
        }, 100)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('line-delete')) {
        store.state.saveHistoryFire = !store.state.saveHistoryFire
        setTimeout(() => {
          const map01 = store.state.map01
          const id = String(e.target.getAttribute('id'))
          const startId = id + '-start'
          const endId = id + '-end'
          const midId = id + '-mid'
          const source = map01.getSource(clickCircleSource.iD)
          const allowSource = map01.getSource(endPointSouce.id)
          const geojson = getSourceData(source)
          const allowGeojson = getSourceData(allowSource)
          let lasso = false
          if (
            geojson.features.find(
              (feature) => feature.properties.id === id && feature.properties.lassoSelected === true
            )
          ) {
            lasso = true
          }
          if (geojson && geojson.features) {
            const newFeatures = geojson.features.filter((feature) => {
              if (lasso) {
                return !feature.properties.lassoSelected
              } else {
                return !(feature.properties && String(feature.properties.id) === id)
              }
            })
            if (newFeatures.length !== geojson.features.length) {
              geojson.features = newFeatures
              map01.getSource(clickCircleSource.iD).setData(geojson)
              store.state.clickCircleGeojsonText = JSON.stringify(geojson)
            }
          }
          if (allowGeojson && allowGeojson.features) {
            const newFeatures = allowGeojson.features.filter((feature) => {
              if (lasso) {
                // ここを絶対に修正する必要あり。今は真偽ともに同じ動作をしている。
                return (
                  !(feature.properties && String(feature.properties.id) === startId) &&
                  !(feature.properties && String(feature.properties.id) === endId) &&
                  !(feature.properties && String(feature.properties.id) === midId)
                )
              } else {
                return (
                  !(feature.properties && String(feature.properties.id) === startId) &&
                  !(feature.properties && String(feature.properties.id) === endId) &&
                  !(feature.properties && String(feature.properties.id) === midId)
                )
              }
            })
            if (newFeatures.length !== allowGeojson.features.length) {
              allowGeojson.features = newFeatures
              map01.getSource(endPointSouce.id).setData(allowGeojson)
            }
          }
          generateSegmentLabelGeoJSON(geojson)
          store.state.isCursorOnPanel = false
          closeAllPopups()
          store.state.popupDialog = false
          store.commit('setDrawDrawer', false)
        }, 100)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('line-sima')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        let source = map01.getSource(clickCircleSource.iD)
        const geojson = getSourceData(source)
        const tgtFeature = geojson.features.find((feature) => {
          return feature.properties.id === id
        })
        store.state.tgtFeature = tgtFeature
        store.state.pointSima = true
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('ninnzahyo-zip')) {
        const coordinates = JSON.parse(e.target.getAttribute('lon-lat'))
        const zipFilename = e.target.innerHTML
        const dir = 'ninizahyoGeojsonZip' + zipFilename.slice(0, 2)
        const zipUrl = `https://kenzkenz.xsrv.jp/ninizahyo/zip/${dir}/${zipFilename}`
        // ZIP を ArrayBuffer 形式で取得
        const resp = await fetch(zipUrl)
        const buf = await resp.arrayBuffer()
        // JSZip で読み込み
        const zip = await JSZip.loadAsync(buf)
        // 中の .geojson ファイルを探す
        const geojsonName = zipFilename.replace(/\.zip$/i, '.geojson')
        let file = zip.file(geojsonName)
        if (!file) {
          // 見つからなければ、アーカイブ内の最初の .geojson を使う
          const candidates = zip.file(/\.geojson$/i)
          if (candidates.length === 0) {
            throw new Error(`${zipFilename} に .geojson が見つかりませんでした`)
          }
          file = candidates[0]
        }
        const geojsonText = await file.async('string')
        removeNini()
        const shiftedGeoJSON = recenterGeoJSON(JSON.parse(geojsonText), coordinates)
        addDraw(shiftedGeoJSON, true, true)
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('ninnzahyo-zip-remove')) {
        removeNini()
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('picture-upload')) {
        const id = String(e.target.getAttribute('id'))
        const pictureUrl = e.target.getAttribute('pictureUrl')
        if (pictureUrl) {
          store.state.pictureUrl = pictureUrl
          store.state.previewUrl = pictureUrl
        } else {
          store.state.pictureUrl = ''
          store.state.previewUrl = ''
        }
        store.state.selectedFile = null
        store.state.drawGeojsonId = id
        store.state.dialogForPicture = true
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('change', async (e) => {
      if (
        e.target &&
        (e.target.classList.contains('offset-x-input') || e.target.classList.contains('offset-y-input'))
      ) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const x = Number(document.querySelector('.offset-x-input').value)
        const y = Number(document.querySelector('.offset-y-input').value)
        const offsetValue = [x, y]
        store.state.clickCircleGeojsonText = geojsonUpdate(
          map01,
          null,
          clickCircleSource.iD,
          id,
          'offsetValue',
          offsetValue
        )
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('input', async (e) => {
      if (
        e.target &&
        (e.target.classList.contains('offset-x-input') || e.target.classList.contains('offset-y-input'))
      ) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const x = Number(document.querySelector('.offset-x-input').value)
        const y = Number(document.querySelector('.offset-y-input').value)
        const offsetValue = [x, y]
        store.state.clickCircleGeojsonText = geojsonUpdate(
          map01,
          null,
          clickCircleSource.iD,
          id,
          'offsetValue',
          offsetValue
        )
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('long-text')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        store.commit('setDrawDrawer', true)
        store.state.popupDialog = false
      }
    })
    // -------------------------------------------------------------------------------------------------------------
    mapElm.addEventListener('click', async (e) => {
      if (e.target && e.target.classList.contains('polygon-height')) {
        const map01 = store.state.map01
        const id = String(e.target.getAttribute('id'))
        const input = document.querySelector('.polygon-height')
        const inputValue = Number(input.value)
        store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, 'height', inputValue)
      }
    })
  })
}

/**
 *
 * @param e
 * @param id
 */
export function lavelUpdate(e, id) {
  if (!store.state.isLabelUpdated) return
  const map01 = store.state.map01
  if (e) {
    id = String(e.target.getAttribute('id'))
  }
  const pointTextElm = document.querySelector('.point-text')
  if (!id || !pointTextElm) return
  const value = pointTextElm.value
  const tgtProp = 'label'
  store.state.clickCircleGeojsonText = geojsonUpdate(map01, null, clickCircleSource.iD, id, tgtProp, value)
  const el =
    document.querySelector(`#txt-marker-${id} .txt-marker-label`) ||
    document.querySelector(`#pic-marker-${id} .txt-marker-label`)
  if (el) el.innerText = truncate(value, 6)
  store.state.isLabelUpdated = false
}
// ラインの最後のセグメントの方向（ベアリング）を計算する関数
export function calculateBearing(coordPrev2, coordPrev, coordLast, endpoint) {
  const map = store.state.map01

  // まずデフォルトは coordPrev を使う
  let [useLon, useLat] = coordPrev

  // coordPrev2 が渡されていて、pixel 距離が小さい場合は coordPrev2 を優先
  if (coordPrev2) {
    const p0 = map.project({ lng: coordPrev[0], lat: coordPrev[1] })
    const p1 = map.project({ lng: coordLast[0], lat: coordLast[1] })
    const distPx = Math.hypot(p1.x - p0.x, p1.y - p0.y)
    const PIXEL_THRESHOLD = 5 // px。必要に応じて調整

    if (distPx < PIXEL_THRESHOLD) {
      ;[useLon, useLat] = coordPrev2
    }
  }

  // ラジアン変換
  const lon1 = (useLon * Math.PI) / 180
  const lat1 = (useLat * Math.PI) / 180
  const lon2 = (coordLast[0] * Math.PI) / 180
  const lat2 = (coordLast[1] * Math.PI) / 180
  const dLon = lon2 - lon1

  const y = Math.sin(dLon) * Math.cos(lat2)
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon)

  let bearing = ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360

  // 矢印向き調整
  return endpoint === 'end' ? bearing + 270 : bearing + 90
}
// オフライン地区を選択する正方形のポリゴンをつくる。
export function createSquarePolygonAtCenter(sideKm = 10, properties = {}) {
  const map01 = store.state.map01
  // 1. 画面中心の座標を取得
  const center = map01.getCenter()
  const centerPoint = turf.point([center.lng, center.lat])
  // 2. 半辺距離を計算 (km)
  const halfSide = sideKm / 2
  // 3. 各角の方位角 (度) NW, NE, SE, SW
  const bearings = [315, 45, 135, 225]
  // 4. bearingごとに目的座標を取得
  const ring = bearings.map(
    (b) => turf.destination(centerPoint, halfSide, b, { units: 'kilometers' }).geometry.coordinates
  )
  // 5. リングを閉じる
  ring.push(ring[0])
  // 6. geojsonCreate でポリゴンを作成・マップに追加
  const feature = geojsonCreate(map01, 'Polygon', [ring], properties)
  return feature
}
// ---------------------------------------------------------------------------------------------------------------------
export function geojsonCreate(map, geoType, coordinates, properties = {}, passedRadius = null) {
  if (!store.state.isEditable && !store.state.isMine) {
    showError('編集不可です')
    return
  }
  // 1. 新しいfeatureを生成
  let features, feature, circleFeature, centerFeature, radius, canterLng, canterLat
  let lastCoord, firstCoord, lastPointFeature, firstPointFeature
  let calc
  switch (geoType) {
    case 'Point':
      // ラベルが未指定でも後続で参照されるため空文字をセット
      // labelTypeは'0'が通常テキストなので??を使用（||だと'0'がfalsyになる）
      feature = turf.point(coordinates, {
        text: properties.label || properties.text || '',
        label: properties.label || properties.text || '',
        balloonDirection: properties.balloonDirection || 'top',
        labelType: properties.labelType ?? '1',
        updated_at: undefined, // 後続でformatYmdHmsを入れないよう明示
        ...properties,
      })
      break
    case 'FreeHand':
    case 'LineString':
      feature = turf.lineString(coordinates, properties)
      break
    case 'Polygon':
      feature = turf.polygon(coordinates, properties)
      calc = calculatePolygonMetrics(feature)
      feature.properties['area'] = calc.area
      feature.properties['perimeter'] = calc.perimeter
      break
    case 'Circle':
      // 引数でradiusが渡された場合はそれを使用（2クリックモード）
      if (passedRadius !== null && passedRadius > 0) {
        radius = passedRadius
      } else if (store.state.circle200Chk) {
        radius = 200
      } else if (store.state.currentCircleRadius > 0) {
        radius = store.state.currentCircleRadius
      } else {
        radius = getScreenMeterDivX(map, 10, 'height')
      }
      features = circleCreate(coordinates[0], coordinates[1], radius)
      canterLng = features.center.geometry.coordinates[0]
      canterLat = features.center.geometry.coordinates[1]
      circleFeature = features.circle
      circleFeature.properties = properties
      // label, label2, showRadiusは渡されたpropertiesを使用（上書きしない）
      // radiusは常に設定
      circleFeature.properties.radius = radius
      circleFeature.properties.canterLng = canterLng
      circleFeature.properties.canterLat = canterLat
      // 円のポリゴンにはlabelTypeを設定しない（ラベル非表示）
      delete circleFeature.properties.labelType
      //----------
      centerFeature = features.center
      centerFeature.properties['isCircleCenter'] = 1
      centerFeature.properties['id'] = circleFeature.properties.id + '-point'
      centerFeature.properties['pairId'] = circleFeature.properties.pairId
      // showRadiusがfalseの場合はラベルを空に
      centerFeature.properties['label'] = properties.showRadius === false ? '' : '半径' + radius + 'm'
      centerFeature.properties['label2'] = properties.label2 || ''
      centerFeature.properties['showRadius'] = properties.showRadius !== false
      centerFeature.properties['point-color'] = 'rgba(0,0,0,0.1)'
      centerFeature.properties['color'] = 'black'
      centerFeature.properties['text-halo-color'] = 'white'
      centerFeature.properties['text-halo-width'] = 2
      centerFeature.properties['text-size'] = 14 // デフォルトテキストサイズ
      centerFeature.properties['isRadius'] = true
      centerFeature.properties['labelType'] = '0'
      centerFeature.properties['offsetValue'] = [0, 1.5]
      centerFeature.properties['textAnchor'] = 'center'
      centerFeature.properties['textJustify'] = 'center'
      centerFeature.properties['radius'] = radius
      centerFeature.properties['canterLng'] = canterLng
      centerFeature.properties['canterLat'] = canterLat
      break
    default:
      throw new Error('未対応のgeoType: ' + geoType)
  }

  // 2. 既存のFeatureCollectionを取得
  const source = map.getSource(clickCircleSource.iD)
  let geojsonData = null
  try {
    geojsonData = getSourceData(source)
  } catch (e) {
    geojsonData = null
  }

  // 3. 既存featureが無ければ新規追加
  if (!geojsonData || !geojsonData.features || geojsonData.features.length === 0) {
    if (geoType === 'Circle') {
      geojsonData = turf.featureCollection([circleFeature, centerFeature])
    } else if (geoType === 'LineString' || geoType === 'FreeHand') {
      geojsonData = turf.featureCollection([feature])
    } else {
      geojsonData = turf.featureCollection([feature])
    }
  } else {
    // 既存FeatureCollectionに追加
    if (geoType === 'Circle') {
      circleFeature.properties.updated_at = formatYmdHms()
      centerFeature.properties.updated_at = formatYmdHms()
      geojsonData = {
        ...geojsonData,
        features: [...geojsonData.features, circleFeature, centerFeature],
      }
    } else if (geoType === 'LineString' || geoType === 'FreeHand') {
      feature.properties.updated_at = formatYmdHms()
      geojsonData = {
        ...geojsonData,
        features: [...geojsonData.features, feature],
      }
    } else {
      feature.properties.updated_at = formatYmdHms()
      geojsonData = {
        ...geojsonData,
        features: [...geojsonData.features, feature],
      }
    }
  }
  if (geoType === 'LineString') {
    generateSegmentLabelGeoJSON(geojsonData)
    generateStartEndPointsFromGeoJSON(geojsonData)
  }
  // 4. ソースに再セット
  source.setData(geojsonData)
  store.state.clickCircleGeojsonText = JSON.stringify(geojsonData)
  store.state.saveHistoryFire = !store.state.saveHistoryFire
  if (store.state.isUsingServerGeojson) {
    if (geoType === 'Circle') {
      saveDrowFeatures([circleFeature, centerFeature])
      // マイドロー用Undoスタックに追加（円は2つのフィーチャー）
      pushMyDrawUndoAction('add', circleFeature.properties.id, null)
      pushMyDrawUndoAction('add', centerFeature.properties.id, null)
    } else {
      saveDrowFeatures([feature])
      // マイドロー用Undoスタックに追加
      pushMyDrawUndoAction('add', feature.properties.id, null)
    }
  }
  if (!store.state.isUsingServerGeojson) {
    featureCollectionAdd()
  }
  markerAddAndRemove(true)

  // 連続描画モードでない場合のみドローモードを終了
  if (!store.state.drawContinuousMode) {
    store.commit('disableAllDraws')
  } else {
    // 連続描画モードの場合は確定ボタンを非表示にする
    // ただし、編集モード(editEnabled)の場合は確定ボタンが必要なので除外
    if (!store.state.editEnabled) {
      store.state.showDrawConfrim = false
    }
  }

  return feature
}

export function getAllVertexPoints(map, geojson) {
  const source = map.getSource(vertexSource.id)
  if (!geojson || !geojson.features) {
    // ★ ソースを空にする
    source.setData({
      type: 'FeatureCollection',
      features: [],
    })
    return
  }
  const features = []
  // 地物単位の編集モード: editingFeatureIdが設定されている場合はその地物のみ
  const editingFeatureId = store.state.editingFeatureId
  geojson.features.forEach((feature, featIdx) => {
    const { geometry, properties, id } = feature
    if (!geometry) return
    if (properties && typeof properties.radius !== 'undefined') return
    if (properties.lassoSelected === true) return
    // 編集中の地物のみに頂点マーカーを表示
    if (editingFeatureId && properties.id !== editingFeatureId) return

    const { type, coordinates } = geometry
    if (type === 'LineString') {
      coordinates.forEach(([lng, lat], i) => {
        features.push({
          type: 'Feature',
          id: `${featIdx}_${i}`,
          geometry: { type: 'Point', coordinates: [lng, lat] },
          properties: {
            vertexIndex: i,
            featureIndex: featIdx,
            parentId: id ?? null,
            ...(properties ? { parentProps: properties } : {}),
          },
        })
      })
    } else if (type === 'Polygon') {
      const ring = coordinates[0] || []
      let pts = ring
      if (pts.length > 1 && pts[0][0] === pts[pts.length - 1][0] && pts[0][1] === pts[pts.length - 1][1]) {
        pts = pts.slice(0, -1)
      }
      pts.forEach(([lng, lat], i) => {
        const isVertex = features.find((f) => f.geometry.coordinates[0] === lng && f.geometry.coordinates[1] === lat)
        if (!isVertex) {
          features.push({
            type: 'Feature',
            id: `${featIdx}_${i}`,
            geometry: { type: 'Point', coordinates: [lng, lat] },
            properties: {
              vertexIndex: i,
              featureIndex: featIdx,
              parentId: id ?? null,
              ...(properties ? { parentProps: properties } : {}),
            },
          })
        }
      })
    } else if (type === 'MultiPolygon') {
      coordinates.forEach((poly, polyIdx) => {
        const ring = poly[0] || []
        let pts = ring
        if (pts.length > 1 && pts[0][0] === pts[pts.length - 1][0] && pts[0][1] === pts[pts.length - 1][1]) {
          pts = pts.slice(0, -1)
        }
        pts.forEach(([lng, lat], i) => {
          features.push({
            type: 'Feature',
            id: `${featIdx}_${polyIdx}_${i}`,
            geometry: { type: 'Point', coordinates: [lng, lat] },
            properties: {
              vertexIndex: i,
              featureIndex: featIdx,
              polygonIndex: polyIdx,
              parentId: id ?? null,
              ...(properties ? { parentProps: properties } : {}),
            },
          })
        })
      })
    }
  })
  const vertexPointsGeojson = {
    type: 'FeatureCollection',
    features,
  }
  source.setData(vertexPointsGeojson)

  return vertexPointsGeojson
}
/**
 * 本体GeoJSONから全中点を生成してmidpoint-sourceにsetData
 * @param {object} map - MapLibreインスタンス
 * @param {object} geojson - 編集中の本体GeoJSON
 */
export function setAllMidpoints(map, geojson) {
  if (!geojson || !geojson.features) {
    map.getSource('midpoint-source').setData({ type: 'FeatureCollection', features: [] })
    return
  }
  const features = []
  // 地物単位の編集モード: editingFeatureIdが設定されている場合はその地物のみ
  const editingFeatureId = store.state.editingFeatureId
  geojson.features.forEach((feature, featIdx) => {
    const { geometry, properties } = feature
    if (!geometry) return
    if (properties.lassoSelected === true) return
    // 編集中の地物のみに中点マーカーを表示
    if (editingFeatureId && properties.id !== editingFeatureId) return
    // 1. サークル判定
    if (properties && typeof properties.radius !== 'undefined') return
    // 2. Pointタイプ地物は絶対に対象外
    if (geometry.type === 'Point') return

    const { type, coordinates } = geometry
    if (type === 'LineString') {
      features.push(...makeMidpointsFeatureCollection(coordinates, false, featIdx, 0))
    } else if (type === 'Polygon') {
      features.push(...makeMidpointsFeatureCollection(coordinates[0], true, featIdx, 0))
    } else if (type === 'MultiPolygon') {
      coordinates.forEach((poly, polyIdx) => {
        features.push(...makeMidpointsFeatureCollection(poly[0], true, featIdx, polyIdx))
      })
    }
  })
  map.getSource('midpoint-source').setData({
    type: 'FeatureCollection',
    features,
  })
}
function makeMidpointsFeatureCollection(coords, isPolygon = false, featureIndex = 0, polygonIndex = 0) {
  const midpoints = []
  let len = coords.length
  let isClosed = false

  if (isPolygon && len > 2 && coords[0][0] === coords[len - 1][0] && coords[0][1] === coords[len - 1][1]) {
    len -= 1 // 最後は除外してループ
    isClosed = true
  }

  const vertexGeojson = getSourceData(store.state.map01.getSource('vertex-source'))

  // 各辺ごと
  for (let i = 0; i < len - 1; i++) {
    const [lng1, lat1] = coords[i]
    const [lng2, lat2] = coords[i + 1]
    const coordinates = [(lng1 + lng2) / 2, (lat1 + lat2) / 2]
    const isVertex = vertexGeojson.features.find((f) => f.geometry.coordinates[0] === coordinates[0])
    if (!isVertex) {
      midpoints.push({
        type: 'Feature',
        id: `mp_${featureIndex}_${polygonIndex}_${i}`,
        geometry: {
          type: 'Point',
          coordinates: coordinates,
        },
        properties: {
          insertIndex: i + 1,
          featureIndex,
          polygonIndex,
        },
      })
    }
  }
  // 閉じたポリゴンのn-1→0の中点を追加
  if (isPolygon && isClosed && len > 2) {
    const [lng1, lat1] = coords[len - 1]
    const [lng2, lat2] = coords[0]
    const coordinates = [(lng1 + lng2) / 2, (lat1 + lat2) / 2]
    const isVertex = vertexGeojson.features.find((f) => f.geometry.coordinates[0] === coordinates[0])
    if (!isVertex) {
      midpoints.push({
        type: 'Feature',
        id: `mp_${featureIndex}_${polygonIndex}_end`,
        geometry: {
          type: 'Point',
          coordinates: coordinates,
        },
        properties: {
          insertIndex: len,
          featureIndex,
          polygonIndex,
        },
      })
    }
  }
  return midpoints
}
/**
 * Polygon/Multipolygonの閉じ忘れ（最初と最後が違う）を自動修復
 * @param {object} geojson - 編集中のFeatureCollection
 */
export function autoCloseAllPolygons(geojson) {
  // フリーハンドを閉じてポリゴンにする設定がOFFの場合は何もしない
  if (!store.state.closeLineToPolygon) return

  if (!geojson || !geojson.features) return
  geojson.features.forEach((feature) => {
    if (!feature.geometry) return
    const { type, coordinates } = feature.geometry
    // Polygon
    if (type === 'Polygon') {
      if (Array.isArray(coordinates[0]) && coordinates[0].length > 2) {
        const ring = coordinates[0]
        const first = ring[0],
          last = ring[ring.length - 1]
        if (first[0] !== last[0] || first[1] !== last[1]) {
          feature.geometry.coordinates[0] = ring.concat([first])
        }
      }
    }
    // MultiPolygon
    else if (type === 'MultiPolygon') {
      coordinates.forEach((poly, polyIdx) => {
        if (Array.isArray(poly[0]) && poly[0].length > 2) {
          const ring = poly[0]
          const first = ring[0],
            last = ring[ring.length - 1]
          if (first[0] !== last[0] || first[1] !== last[1]) {
            feature.geometry.coordinates[polyIdx][0] = ring.concat([first])
          }
        }
      })
    }
  })
}

export function getVertexPoints(map, geoType, coords, isPolygon = false) {
  // Polygonの場合、coords[0]（外環）を使用
  if (geoType === 'Circle') return
  let points = coords
  if (isPolygon) {
    points = coords[0]
    if (
      points.length > 1 &&
      points[0][0] === points[points.length - 1][0] &&
      points[0][1] === points[points.length - 1][1]
    ) {
      points = points.slice(0, -1)
    }
  }
  const source = map.getSource(vertexSource.id)
  let geojsonData = null
  try {
    geojsonData = getSourceData(source)
  } catch (e) {
    geojsonData = null
  }
  const features = points.map(([lng, lat], i) => ({
    type: 'Feature',
    id: i,
    geometry: {
      type: 'Point',
      coordinates: [lng, lat],
    },
    properties: { vertexIndex: i },
  }))
  geojsonData = {
    ...geojsonData,
    features: [...geojsonData.features, ...features],
  }
  source.setData(geojsonData)
}

export function getScreenMeterDivX(map, x, direction = 'width') {
  const canvas = map.getCanvas()
  const w = canvas.width
  const h = canvas.height
  let coord1, coord2

  if (direction === 'width') {
    // 左端と右端（画面中央高さ）
    coord1 = map.unproject([0, h / 2])
    coord2 = map.unproject([w, h / 2])
  } else {
    // 上端と下端（画面中央幅）
    coord1 = map.unproject([w / 2, 0])
    coord2 = map.unproject([w / 2, h])
  }

  // turf.js で距離計算（単位: meters）
  const from = [coord1.lng, coord1.lat]
  const to = [coord2.lng, coord2.lat]
  const distance = turf.distance(from, to, { units: 'meters' })
  return Math.floor(distance / x)
}

export function circleCreate(lng, lat, m) {
  const center = [lng, lat]
  // const radiusKm = 0.2; // 200m = 0.2km
  const radiusKm = m / 1000
  const steps = 64
  const circleGeoJson = turf.circle(center, radiusKm, {
    steps: steps,
    units: 'kilometers',
  })
  const centerFeature = turf.centerOfMass(circleGeoJson)
  return { center: centerFeature, circle: circleGeoJson }
}

/**
 *
 * @param map
 * @param geoType
 * @param sourceId
 * @param id
 * @param tgtProp
 * @param value
 * @param radius
 * @returns {*}
 */
// const neonColors = {
//     orange: '#FF8000',   // Neon Orange
//     green:  '#39FF14',   // Neon Green
//     blue:   '#1F51FF',   // Neon Blue
//     black:  '#1C1C1C',   // Deep Glow Black (substitute)
//     red:    '#FF073A'    // Neon Red
// };
const neonColors = {
  orange: 'rgba(255, 128,   0, 0.5)', // Neon Orange
  green: 'rgba( 57, 255,  20, 0.5)', // Neon Green
  blue: 'rgba( 31,  81, 255, 0.5)', // Neon Blue
  black: 'rgba( 28,  28,  28, 0.5)', // Deep Glow Black (substitute)
  red: 'rgba(255,   7,  58, 0.5)', // Neon Red
}

export function geojsonUpdate(map, geoType, sourceId, id, tgtProp, value, radius) {
  store.state.saveHistoryFire = !store.state.saveHistoryFire
  const source = map.getSource(sourceId)
  if (!source) return
  const geojson = getSourceData(source)
  const drawFeatures = []
  let changed = false

  // マイドロー用：更新前の状態を保存（Undo用）
  const prevStatesForUndo = new Map()
  if (store.state.isUsingServerGeojson && geojson && geojson.features) {
    geojson.features.forEach((feature) => {
      if (feature.properties?.id && feature.properties.id !== 'config') {
        // 更新対象になりそうなフィーチャーの現在の状態を保存
        const shouldCheck = feature.properties.lassoSelected === true || String(feature.properties.id) === String(id)
        if (shouldCheck) {
          prevStatesForUndo.set(String(feature.properties.id), JSON.parse(JSON.stringify(feature)))
        }
      }
    })
  }

  if (geojson && geojson.features) {
    // idが一致するfeatureを検索
    let found = false
    let circleFeatureGeometry, centerFeature
    // lasso が存在するかを boolean で判定（オブジェクトではなく真偽値にしておくと扱いやすい）
    const isLasso = geojson.features.some((f) => f.properties?.id === id && f.properties?.lassoSelected === true)
    const updateFeatures = []
    geojson.features.forEach((feature) => {
      // lasso が見つかっていれば lassoSelected、なければ id マッチをチェック
      const shouldUpdate = isLasso ? feature.properties.lassoSelected === true : String(feature.properties.id) === id
      if (shouldUpdate) {
        if (tgtProp === 'pictureUrl') {
          if (value.pictureUrl === 'delete') {
            delete feature.properties.pictureUrl
          } else {
            if (value.pictureUrl) feature.properties.pictureUrl = value.pictureUrl
          }
          feature.properties.borderRadius = value.borderRadius
          feature.properties.containerSize = value.containerSize
          feature.properties.containerColor = value.containerColor
          feature.properties.updated_at = formatYmdHms()
          // feature.properties.labelType= value.labelType
        } else {
          feature.properties[tgtProp] = value
          // offsetValueは必ず配列にする（文字列だとMapLibreのlookupSymbolFeaturesが壊れる）
          if (tgtProp === 'offsetValue' && !Array.isArray(feature.properties.offsetValue)) {
            feature.properties.offsetValue = [0, 0]
          }
          feature.properties.updated_at = formatYmdHms()
        }
        // ----------------------------------------------------------
        if (geoType === 'Circle') {
          // 中心座標の取得優先順位:
          // 1. 中心点（{id}-point）の座標（最も信頼できる）
          // 2. canterLng/canterLat
          // 3. geometryから計算（最後の手段）
          let circleLng, circleLat

          // まず中心点から座標を取得（最も信頼できる）
          const centerPoint = geojson.features.find((f) => f.properties.id === id + '-point')
          if (centerPoint && centerPoint.geometry?.coordinates) {
            circleLng = centerPoint.geometry.coordinates[0]
            circleLat = centerPoint.geometry.coordinates[1]
          }

          // 中心点がない場合はcanterLng/canterLatを使用
          if (typeof circleLng !== 'number' || typeof circleLat !== 'number') {
            circleLng = feature.properties.canterLng
            circleLat = feature.properties.canterLat
          }

          // それでもない場合はgeometryから計算（最後の手段）
          if ((typeof circleLng !== 'number' || typeof circleLat !== 'number') && feature.geometry?.coordinates?.[0]) {
            const coords = feature.geometry.coordinates[0]
            const sum = coords.reduce((acc, [lng, lat]) => [acc[0] + lng, acc[1] + lat], [0, 0])
            circleLng = sum[0] / coords.length
            circleLat = sum[1] / coords.length
          }

          // 取得した座標をプロパティに保存
          if (typeof circleLng === 'number' && typeof circleLat === 'number') {
            feature.properties.canterLng = circleLng
            feature.properties.canterLat = circleLat
          }
          // 座標が取得できない場合はスキップ
          if (typeof circleLng !== 'number' || typeof circleLat !== 'number') {
            console.warn('円の中心座標が取得できません:', id)
            return
          }
          const features = circleCreate(circleLng, circleLat, radius)
          circleFeatureGeometry = features.circle.geometry
          feature.geometry = circleFeatureGeometry
          feature.properties.label = radius
          feature.properties.radius = radius
          feature.properties.label2 = value
          feature.properties.updated_at = formatYmdHms()
          centerFeature = geojson.features.find((f) => f.properties.id === id + '-point')
          // labelには半径のみ、label2にはテキストのみを設定（layers.jsで結合）
          centerFeature.properties.label = '半径' + radius + 'm'
          centerFeature.properties.label2 = value
          centerFeature.properties.radius = radius
          // isRadiusは既存の値を維持（変更しない）
          // centerFeature.properties.isRadius = true
          centerFeature.properties.labelType = '0'
          centerFeature.properties.color = 'black'
          centerFeature.properties['text-halo-color'] = 'white'
          centerFeature.properties['text-halo-width'] = 2
          // label2がある場合（2段表示）は下げる
          centerFeature.properties.offsetValue = value ? [0, 2.0] : [0, 1.5]
          centerFeature.properties.textAnchor = 'center'
          centerFeature.properties.textJustify = 'center'
          centerFeature.properties.updated_at = formatYmdHms()

          updateFeatures.push(centerFeature)
        } else if (geoType === 'LineString') {
          const keikoValue = neonColors[value]
          feature.properties['keiko-color'] = keikoValue
          feature.properties.arrow = 'arrow_' + value
        }
        // ---------------------------------------------------------
        updateFeatures.push(feature)
        changed = true
        found = true
        drawFeatures.push(feature)
        const key = feature.geometry?.coordinates.join()
        if (key) {
          removeThumbnailMarkerByKey(key)
        }
        if (feature.geometry) {
          /**
           * 面積と周長が吹っ飛ぶ謎の現象があったため再度計算、付与
           */
          const calc = calculatePolygonMetrics(feature)
          if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon') {
            feature.properties['area'] = calc.area
            feature.properties['perimeter'] = calc.perimeter
          } else if (feature.geometry.type === 'LineString' || feature.geometry.type === 'MultiLineString') {
            feature.properties['area'] = calc.perimeter
          }
        }
      }
    })
    // 見つからなかったら新しく作成
    if (!found && id === 'config') {
      const newFeature = {
        type: 'Feature',
        properties: {
          id: 'config',
        },
      }
      // tgtProp, valueもセット
      newFeature.properties[tgtProp] = value
      geojson.features.push(newFeature)
      changed = true
    }
    if (changed) {
      if (id !== 'config') map.getSource(sourceId).setData(geojson)
      store.state.updatePermalinkFire = !store.state.updatePermalinkFire

      // 選択レイヤーも同期して更新（円の半径変更時など）
      if (geoType === 'Circle' && circleFeatureGeometry) {
        const selectionSource = map.getSource('draw-selection-source')
        if (selectionSource) {
          const selectionData = getSourceData(selectionSource)
          if (selectionData && selectionData.features && selectionData.features.length > 0) {
            // 選択中のフィーチャーが更新対象の円であれば、geometryを更新
            const selectedFeature = selectionData.features.find((f) => f.properties?.id === id)
            if (selectedFeature) {
              selectedFeature.geometry = circleFeatureGeometry
              selectionSource.setData(selectionData)
            }
          }
        }
      }
      if (!store.state.isUsingServerGeojson) {
        setTimeout(() => {
          featureCollectionAdd()
          markerAddAndRemove(true)
        }, 1000)
      }
      if (drawFeatures.length === 1) {
        store.state.drawFeature = drawFeatures[0]
      }

      // マイドロー用Undoスタックに追加（更新前の状態を保存）
      if (store.state.isUsingServerGeojson) {
        updateFeatures.forEach((f) => {
          const featureId = String(f.properties?.id)
          if (featureId && featureId !== 'config' && prevStatesForUndo.has(featureId)) {
            pushMyDrawUndoAction('modify', featureId, prevStatesForUndo.get(featureId))
          }
        })
      }

      saveDrowFeatures(updateFeatures)
      if (store.state.isSmall500) {
        // 謎の表示をするので強制的に消す。
        setTimeout(() => {
          const drawListEl = document.querySelector('#drawList')
          if (drawListEl) {
            drawListEl.style.display = 'none'
          }
        }, 1000)
      }

      return escapeHTML(JSON.stringify(toRaw(geojson)))
    }
  }
}

// ラインのラベル用に距離を計算したgeojsonを作る、
export function generateSegmentLabelGeoJSON(geojson) {
  function kmOrm(value) {
    return value >= 1 ? `約${value.toFixed(1)}km` : `約${(value * 1000).toFixed(1)}m`
  }
  const map01 = store.state.map01
  // map01またはソースが存在しない場合は早期リターン
  if (!map01 || !map01.getSource('segment-label-source')) {
    return
  }
  const features = []
  if (!geojson || !geojson.features) {
    map01.getSource('segment-label-source').setData({
      type: 'FeatureCollection',
      features: [],
    })
    return
  }
  geojson.features.forEach((feature) => {
    if (feature.properties.id === 'config') return
    if (!feature || feature.geometry.type !== 'LineString' || feature.properties['free-hand']) return

    const coords = feature.geometry.coordinates
    let totalDistance = 0
    for (let i = 0; i < coords.length - 1; i++) {
      const from = coords[i]
      const to = coords[i + 1]
      const segment = turf.lineString([from, to])

      const center = turf.midpoint(turf.point(from), turf.point(to))
      const dist = turf.length(segment, { units: 'kilometers' })
      totalDistance += dist
      const distance = kmOrm(dist)
      const isLast = i === coords.length - 2 // 最後のセグメント
      if (isLast) {
        totalDistance = kmOrm(totalDistance)
      }
      const distanceLabel = isLast && i > 0 ? `${distance}\n(計:${totalDistance})` : distance

      const bearingAtMid = calculateBearing(null, from, to, 'end')

      let textBearing
      if (bearingAtMid < 450) {
        textBearing = bearingAtMid
      } else {
        textBearing = bearingAtMid + 900
      }
      features.push({
        type: 'Feature',
        geometry: center.geometry,
        properties: {
          id: feature.properties.id, // 親の線のID
          calc: feature.properties.calc || 0,
          distance: distanceLabel,
          index: i + 1,
          textBearing: textBearing,
        },
      })
    }

    // 頂点の角度ラベル（最初と最後の頂点を除く）
    for (let i = 1; i < coords.length - 1; i++) {
      const prev = coords[i - 1]
      const curr = coords[i]
      const next = coords[i + 1]

      // ベクトル計算で内角を求める
      const v1x = prev[0] - curr[0]
      const v1y = prev[1] - curr[1]
      const v2x = next[0] - curr[0]
      const v2y = next[1] - curr[1]

      // 内積とベクトルの長さから角度を計算
      const dot = v1x * v2x + v1y * v2y
      const len1 = Math.sqrt(v1x * v1x + v1y * v1y)
      const len2 = Math.sqrt(v2x * v2x + v2y * v2y)
      const cosAngle = dot / (len1 * len2)
      // 数値誤差で-1〜1を超える場合があるのでクランプ
      const clampedCos = Math.max(-1, Math.min(1, cosAngle))
      const angleRad = Math.acos(clampedCos)
      const angleDeg = Math.round(angleRad * 180 / Math.PI)

      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: curr,
        },
        properties: {
          id: feature.properties.id,
          calc: feature.properties.calc || 0,
          distance: `${angleDeg}°`,
          index: i,
          isAngle: true,
          textBearing: 0,
        },
      })
    }
  })
  const labelGeojson = {
    type: 'FeatureCollection',
    features,
  }
  // ラベル用ソースに反映
  map01.getSource('segment-label-source').setData(labelGeojson)
}

// 色から矢印アイコン名を取得するヘルパー関数
function getArrowIconFromColor(color) {
  // 利用可能な矢印色: black, red, blue, green, orange
  if (!color) return 'arrow_black'

  // HEX形式の場合は変換しない（黒をデフォルトにする）
  if (color.startsWith('#')) {
    return 'arrow_black'
  }

  // 色名に基づいてマッピング
  const colorMap = {
    black: 'arrow_black',
    red: 'arrow_red',
    blue: 'arrow_blue',
    green: 'arrow_green',
    orange: 'arrow_orange',
    hotpink: 'arrow_red', // ピンクは赤に近い
  }

  return colorMap[color] || 'arrow_black'
}

// ラインに矢印のポイントを作る
export function generateStartEndPointsFromGeoJSON(geojson) {
  const map01 = store.state.map01
  // map01またはソースが存在しない場合は早期リターン
  if (!map01 || !map01.getSource('end-point-source')) {
    return { type: 'FeatureCollection', features: [] }
  }
  const pointFeatures = []
  if (!geojson || !geojson.features) {
    const emptyGeoJSON = {
      type: 'FeatureCollection',
      features: [],
    }
    map01.getSource('end-point-source').setData(emptyGeoJSON)
    return emptyGeoJSON
  }

  geojson.features.forEach((feature) => {
    if (!feature || !feature.geometry || !feature.geometry.coordinates) return
    if (feature.properties?.id === 'config') return
    if (feature.geometry.type !== 'LineString' || feature.properties?.['free-hand']) return

    const coords = feature.geometry.coordinates
    const props = feature.properties || {}
    if (coords.length < 2) return

    // 座標の有効性チェック（スケッチの消しゴムで無効なfeatureが残る場合の対策）
    const hasValidCoords = coords.every(c => Array.isArray(c) && c.length >= 2 && !isNaN(c[0]) && !isNaN(c[1]))
    if (!hasValidCoords) return

    const [first, second] = coords
    const last = coords[coords.length - 1]
    const prev = coords[coords.length - 2]
    let prev2 = null
    if (coords.length > 2) {
      prev2 = coords[coords.length - 3]
    }

    // 始点
    {
      pointFeatures.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: first },
        properties: {
          id: props.id + '-start',
          pairId: props.pairId || null,
          endpoint: 'start',
          'arrow-type': props['arrow-type'] || 'end',
          'arrow-color': props.color || 'black', // SDF用の色
          'line-width': props['line-width'] || 3, // 線幅
          bearing: calculateBearing(null, first, second, 'start'),
          label: props.labelType === 'start' ? props.label : '',
          color: props.color || 'black',
        },
      })
    }
    // 中間点
    {
      const line = turf.lineString(coords)
      // 全長をメートルで取得
      const totalM = turf.length(line, { units: 'meters' })

      // 非常に短い線（1m未満）はスキップ
      if (totalM < 1) return

      // 半分の距離でポイントを取得
      const midCoord = turf.along(line, totalM / 2, { units: 'meters' }).geometry.coordinates

      // 全長 totalM の半分の距離
      const midDistance = totalM / 2
      // 前後にずらす距離（メートル単位で小さな値を指定）
      const epsilon = Math.min(0.5, midDistance * 0.1) // 0.5mか全長の10%の小さい方
      // midCoord の少し手前のポイント
      const prevPt = turf.along(line, Math.max(0, midDistance - epsilon), { units: 'meters' })
      // midCoord の少し先のポイント
      const nextPt = turf.along(line, Math.min(totalM, midDistance + epsilon), { units: 'meters' })

      const bearingAtMid = calculateBearing(null, prevPt.geometry.coordinates, nextPt.geometry.coordinates, 'end')

      let textBearing
      if (bearingAtMid < 450) {
        textBearing = bearingAtMid
      } else {
        textBearing = bearingAtMid + 900
      }

      pointFeatures.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: midCoord },
        properties: {
          id: props.id + '-mid',
          pairId: props.pairId || null,
          endpoint: 'mid',
          'arrow-type': 'mid',
          'arrow-color': props.color || 'black', // SDF用の色
          'line-width': props['line-width'] || 3, // 線幅
          label: props.labelType === 'mid' ? props.label : '',
          color: props.color || 'black',
          textBearing: textBearing,
        },
      })
    }
    // 終点
    {
      pointFeatures.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: last },
        properties: {
          id: props.id + '-end',
          pairId: props.pairId || null,
          endpoint: 'end',
          'arrow-type': props['arrow-type'] || 'end',
          'arrow-color': props.color || 'black', // SDF用の色
          'line-width': props['line-width'] || 3, // 線幅
          bearing: calculateBearing(prev2, prev, last, 'end'),
        },
      })
    }
  })
  const pointGeoJSON = {
    type: 'FeatureCollection',
    features: pointFeatures,
  }

  // SDFアイコンが存在しない場合は追加（高解像度でスムーズに）
  if (!map01.hasImage('arrow-sdf')) {
    const arrowCanvas = document.createElement('canvas')
    const arrowSize = 64 // 高解像度でスムーズな縁に
    arrowCanvas.width = arrowSize
    arrowCanvas.height = arrowSize
    const ctx = arrowCanvas.getContext('2d', { willReadFrequently: true })
    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'
    ctx.fillStyle = '#ffffff'
    ctx.beginPath()
    ctx.moveTo(arrowSize * 0.9, arrowSize * 0.5)
    ctx.lineTo(arrowSize * 0.1, arrowSize * 0.15)
    ctx.lineTo(arrowSize * 0.1, arrowSize * 0.85)
    ctx.closePath()
    ctx.fill()
    const arrowImageData = ctx.getImageData(0, 0, arrowSize, arrowSize)
    map01.addImage('arrow-sdf', arrowImageData, { sdf: true })
  }

  map01.getSource('end-point-source').setData(pointGeoJSON)
  // 再描画をトリガー
  if (map01.triggerRepaint) map01.triggerRepaint()
  return pointGeoJSON
}

export async function deleteAll(noConfrim) {
  if (store.state.isUsingServerGeojson && !store.state.isMine) {
    showError('全削除はオーナーしかできません。')
    return
  }
  if (!noConfrim) {
    const ok = await vConfirm('全て削除しますか？', {
      title: '',
      okText: '全て削除',
      icon: null,
    })
    if (!ok) return
  }
  const map01 = store.state.map01
  let source = map01.getSource(clickCircleSource.iD)
  const geojson = getSourceData(source)
  await featuresDelete(geojson.features.filter((f) => f.properties.id !== 'config').map((f) => f.properties.id))
  const configFeature = store.state.baseConfigFeature
  store.state.configFeature = configFeature
  const fc = {
    type: 'FeatureCollection',
    features: [configFeature],
  }
  source.setData(fc)
  await saveDrowFeatures([configFeature])

  source = map01.getSource(endPointSouce.id)
  // 空のGeoJSON FeatureCollectionを設定する
  source.setData({
    type: 'FeatureCollection',
    features: [],
  })

  store.state.clickCircleGeojsonText = JSON.stringify(fc)
  store.state.clickCircleGeojsonTextMyroom = JSON.stringify(fc)
  getAllVertexPoints(map01)
  setAllMidpoints(map01)
  generateSegmentLabelGeoJSON({
    type: 'FeatureCollection',
    features: [],
  })
  closeAllPopups()
  store.commit('setDrawDrawer', false)

  store.state.printTitleText = ''
  store.state.textPx = 30
  store.state.titleColor = ''
  store.state.titleDirection = 'a4-vertical'
  store.state.drawVisible = true
  store.state.drawOpacity = 1

  if (!store.state.isUsingServerGeojson) {
    featureCollectionAdd()
    markerAddAndRemove(true)
  }
  store.state.updatePermalinkFire = !store.state.updatePermalinkFire
}

export function escapeHTML(str) {
  return str.replace(/&/g, 'amp\\n')
}
export function unescapeHTML(str) {
  return str.replace(/amp/g, '&')
}

export function colorNameToRgba(colorName, alpha = 1) {
  // HEXカラー（#で始まる）の場合
  if (typeof colorName === 'string' && colorName.startsWith('#')) {
    const hex = colorName.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)
    return `rgba(${r},${g},${b},${alpha})`
  }

  // 定義: 色名 → [R, G, B]
  const colorTable = {
    orange: [255, 165, 0],
    green: [0, 128, 0],
    blue: [0, 0, 255],
    black: [0, 0, 0],
    red: [255, 0, 0],
    yellow: [255, 255, 0],
    hotpink: [255, 105, 180],
  }
  const rgb = colorTable[colorName.toLowerCase()]
  if (!rgb) return 'rgba(0,0,0,0)' // 未定義色名の場合
  return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`
}

export let lastGeojson = null

export function watchGeojsonChange() {
  const map = store.state.map01
  requestAnimationFrame(() => {

    const source = map.getSource('click-circle-source')
    if (!source) {
      // ソースがまだない → 次フレームで再チェック
      watchGeojsonChange()
      return
    }

    const current = getSourceData(source)

    if (JSON.stringify(current) !== JSON.stringify(lastGeojson)) {
      // 差分あり
      lastGeojson = JSON.parse(JSON.stringify(current)) // ← ちゃんとコピーしないと比較できない
      console.warn('GeoJSON changed')
      store.state.saveHistoryFire = !store.state.saveHistoryFire
    }

    watchGeojsonChange() // 🔁 次のフレームへ
  })
}
